export const getData = (key = "") => {
  let data = [
    {
      SMSID: 715689,
      DateTime: "01/11/2021 00:23:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702334903,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 785625",
    },
    {
      SMSID: 715690,
      DateTime: "01/11/2021 00:23:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702334903,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 123741",
    },
    {
      SMSID: 715692,
      DateTime: "01/11/2021 00:28:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751645674,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 599851",
    },
    {
      SMSID: 715693,
      DateTime: "01/11/2021 00:35:16",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760583689,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 251410",
    },
    {
      SMSID: 715694,
      DateTime: "01/11/2021 03:30:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256782664235,
      Interface: "Shortcode",
      Message:
        "You won! BetID296032, has won and the payout UGX13148 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 715701,
      DateTime: "01/11/2021 05:58:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777793016,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 315827",
    },
    {
      SMSID: 715706,
      DateTime: "01/11/2021 06:38:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760420614,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 220508",
    },
    {
      SMSID: 715707,
      DateTime: "01/11/2021 06:58:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785655755,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 516103",
    },
    {
      SMSID: 715708,
      DateTime: "01/11/2021 06:59:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752425273,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 793539",
    },
    {
      SMSID: 715709,
      DateTime: "01/11/2021 07:55:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780892243,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 780319",
    },
    {
      SMSID: 715710,
      DateTime: "01/11/2021 08:03:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780892243,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 209646",
    },
    {
      SMSID: 715758,
      DateTime: "01/11/2021 11:34:16",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785655755,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 772161",
    },
    {
      SMSID: 715761,
      DateTime: "01/11/2021 11:41:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774075244,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 111828",
    },
    {
      SMSID: 715762,
      DateTime: "01/11/2021 11:42:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774075244,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 134052",
    },
    {
      SMSID: 715763,
      DateTime: "01/11/2021 11:42:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760582221,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 290450",
    },
    {
      SMSID: 715764,
      DateTime: "01/11/2021 11:43:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782901145,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 579267",
    },
    {
      SMSID: 715769,
      DateTime: "01/11/2021 12:03:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703726543,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 148635",
    },
    {
      SMSID: 715770,
      DateTime: "01/11/2021 12:04:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703726543,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 941149",
    },
    {
      SMSID: 715771,
      DateTime: "01/11/2021 12:12:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774075244,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 264971",
    },
    {
      SMSID: 715772,
      DateTime: "01/11/2021 12:14:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783013043,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 137265",
    },
    {
      SMSID: 715773,
      DateTime: "01/11/2021 12:15:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783013043,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 697156",
    },
    {
      SMSID: 715784,
      DateTime: "01/11/2021 12:34:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706473214,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 405840",
    },
    {
      SMSID: 715788,
      DateTime: "01/11/2021 13:31:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752018016,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 720879",
    },
    {
      SMSID: 715798,
      DateTime: "01/11/2021 13:47:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754197806,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 214521",
    },
    {
      SMSID: 715799,
      DateTime: "01/11/2021 13:49:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754197806,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 944902",
    },
    {
      SMSID: 715802,
      DateTime: "01/11/2021 13:58:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771929652,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 122076",
    },
    {
      SMSID: 715803,
      DateTime: "01/11/2021 14:10:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786152406,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 774086",
    },
    {
      SMSID: 715804,
      DateTime: "01/11/2021 14:30:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789140513,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 125669",
    },
    {
      SMSID: 715805,
      DateTime: "01/11/2021 14:32:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789140513,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 133039",
    },
    {
      SMSID: 715806,
      DateTime: "01/11/2021 14:32:58",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704810555,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 989461",
    },
    {
      SMSID: 715809,
      DateTime: "01/11/2021 14:33:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704810555,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 948594",
    },
    {
      SMSID: 715812,
      DateTime: "01/11/2021 14:34:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704810555,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 133197",
    },
    {
      SMSID: 715832,
      DateTime: "01/11/2021 15:23:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782566142,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 973073",
    },
    {
      SMSID: 715861,
      DateTime: "01/11/2021 16:43:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256700480358,
      Interface: "Shortcode",
      Message:
        "You won! BetID296365, has won and the payout UGX3293 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 715880,
      DateTime: "01/11/2021 18:09:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753066997,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 686072",
    },
    {
      SMSID: 715881,
      DateTime: "01/11/2021 18:21:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772938830,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 877823",
    },
    {
      SMSID: 715882,
      DateTime: "01/11/2021 18:22:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772938830,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 115785",
    },
    {
      SMSID: 715883,
      DateTime: "01/11/2021 18:22:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772938830,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 198058",
    },
    {
      SMSID: 715895,
      DateTime: "01/11/2021 18:49:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783530516,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 771460",
    },
    {
      SMSID: 715900,
      DateTime: "01/11/2021 19:12:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771372052,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 618699",
    },
    {
      SMSID: 715923,
      DateTime: "01/11/2021 19:33:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752571130,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 517038",
    },
    {
      SMSID: 715954,
      DateTime: "01/11/2021 19:57:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780518559,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 296064",
    },
    {
      SMSID: 715959,
      DateTime: "01/11/2021 20:14:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740922970,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 347703",
    },
    {
      SMSID: 715962,
      DateTime: "01/11/2021 20:17:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704735557,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 104118",
    },
    {
      SMSID: 715967,
      DateTime: "01/11/2021 20:22:16",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750112988,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 343888",
    },
    {
      SMSID: 715968,
      DateTime: "01/11/2021 20:22:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704735557,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 274994",
    },
    {
      SMSID: 715969,
      DateTime: "01/11/2021 20:23:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750112988,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 625684",
    },
    {
      SMSID: 715970,
      DateTime: "01/11/2021 20:24:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750112988,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 753674",
    },
    {
      SMSID: 715971,
      DateTime: "01/11/2021 20:24:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750112988,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 710913",
    },
    {
      SMSID: 715995,
      DateTime: "01/11/2021 20:47:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785055382,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 967519",
    },
    {
      SMSID: 716000,
      DateTime: "01/11/2021 20:56:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773681859,
      Interface: "Shortcode",
      Message:
        "You won! BetID296415, has won and the payout UGX883 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716003,
      DateTime: "01/11/2021 21:28:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702334903,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 149625",
    },
    {
      SMSID: 716004,
      DateTime: "01/11/2021 21:30:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702334903,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 414934",
    },
    {
      SMSID: 716005,
      DateTime: "01/11/2021 21:34:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782657364,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 262902",
    },
    {
      SMSID: 716006,
      DateTime: "01/11/2021 21:35:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782657364,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 724223",
    },
    {
      SMSID: 716007,
      DateTime: "01/11/2021 21:36:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782657364,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 974830",
    },
    {
      SMSID: 716010,
      DateTime: "01/11/2021 21:37:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782657364,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 249474",
    },
    {
      SMSID: 716013,
      DateTime: "01/11/2021 21:46:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756056876,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 286128",
    },
    {
      SMSID: 716015,
      DateTime: "01/11/2021 21:54:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752364045,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 997975",
    },
    {
      SMSID: 716020,
      DateTime: "01/11/2021 22:14:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782657364,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 392945",
    },
    {
      SMSID: 716021,
      DateTime: "01/11/2021 22:37:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782901145,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 504693",
    },
    {
      SMSID: 716022,
      DateTime: "01/11/2021 22:38:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782901145,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 390502",
    },
    {
      SMSID: 716023,
      DateTime: "01/11/2021 23:00:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777697274,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 795008",
    },
    {
      SMSID: 716024,
      DateTime: "01/11/2021 23:01:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777697274,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 168221",
    },
    {
      SMSID: 716025,
      DateTime: "01/11/2021 23:02:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777697274,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 190429",
    },
    {
      SMSID: 716026,
      DateTime: "01/11/2021 23:04:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777697274,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 787262",
    },
    {
      SMSID: 716027,
      DateTime: "01/11/2021 23:07:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777697274,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 546007",
    },
    {
      SMSID: 716028,
      DateTime: "01/11/2021 23:08:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750140304,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 901944",
    },
    {
      SMSID: 716029,
      DateTime: "01/11/2021 23:08:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777697274,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 676636",
    },
    {
      SMSID: 716030,
      DateTime: "01/11/2021 23:20:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708470635,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 939556",
    },
    {
      SMSID: 716031,
      DateTime: "01/11/2021 23:21:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708470635,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 675989",
    },
    {
      SMSID: 716036,
      DateTime: "02/11/2021 00:43:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703495934,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 794918",
    },
    {
      SMSID: 716037,
      DateTime: "02/11/2021 01:22:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759188823,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 781126",
    },
    {
      SMSID: 716038,
      DateTime: "02/11/2021 01:23:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759188823,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 124228",
    },
    {
      SMSID: 716039,
      DateTime: "02/11/2021 01:23:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759188823,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 931651",
    },
    {
      SMSID: 716040,
      DateTime: "02/11/2021 01:23:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759188823,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 954065",
    },
    {
      SMSID: 716041,
      DateTime: "02/11/2021 01:24:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759188823,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 130466",
    },
    {
      SMSID: 716042,
      DateTime: "02/11/2021 01:24:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759188823,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 163359",
    },
    {
      SMSID: 716043,
      DateTime: "02/11/2021 01:24:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758074108,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 732546",
    },
    {
      SMSID: 716048,
      DateTime: "02/11/2021 05:54:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782657364,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 928060",
    },
    {
      SMSID: 716049,
      DateTime: "02/11/2021 05:54:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782657364,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 905890",
    },
    {
      SMSID: 716050,
      DateTime: "02/11/2021 06:04:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708658770,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 420636",
    },
    {
      SMSID: 716051,
      DateTime: "02/11/2021 06:10:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: "256O778025477",
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 257903",
    },
    {
      SMSID: 716052,
      DateTime: "02/11/2021 06:10:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: "256O778025477",
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 128073",
    },
    {
      SMSID: 716053,
      DateTime: "02/11/2021 06:11:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: "256O778025477",
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 642563",
    },
    {
      SMSID: 716054,
      DateTime: "02/11/2021 06:13:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702294926,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 488027",
    },
    {
      SMSID: 716063,
      DateTime: "02/11/2021 06:56:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784225517,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 567580",
    },
    {
      SMSID: 716064,
      DateTime: "02/11/2021 06:59:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784225517,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 694650",
    },
    {
      SMSID: 716065,
      DateTime: "02/11/2021 07:00:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781066785,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 509567",
    },
    {
      SMSID: 716068,
      DateTime: "02/11/2021 07:17:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705437679,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 956933",
    },
    {
      SMSID: 716069,
      DateTime: "02/11/2021 07:25:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782657364,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 696430",
    },
    {
      SMSID: 716078,
      DateTime: "02/11/2021 08:35:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707583998,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 610039",
    },
    {
      SMSID: 716092,
      DateTime: "02/11/2021 10:10:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754274870,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 116199",
    },
    {
      SMSID: 716097,
      DateTime: "02/11/2021 10:22:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740933914,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 946129",
    },
    {
      SMSID: 716098,
      DateTime: "02/11/2021 10:33:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760813771,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 812135",
    },
    {
      SMSID: 716112,
      DateTime: "02/11/2021 11:32:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782581077,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 408531",
    },
    {
      SMSID: 716115,
      DateTime: "02/11/2021 12:03:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758791987,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 164531",
    },
    {
      SMSID: 716136,
      DateTime: "02/11/2021 13:05:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780582324,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 642888",
    },
    {
      SMSID: 716145,
      DateTime: "02/11/2021 13:33:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774242127,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 549396",
    },
    {
      SMSID: 716156,
      DateTime: "02/11/2021 14:20:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760583689,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 236121",
    },
    {
      SMSID: 716157,
      DateTime: "02/11/2021 14:24:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760583689,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 945855",
    },
    {
      SMSID: 716200,
      DateTime: "02/11/2021 14:49:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787081823,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 336802",
    },
    {
      SMSID: 716207,
      DateTime: "02/11/2021 14:51:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760201882,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 879176",
    },
    {
      SMSID: 716214,
      DateTime: "02/11/2021 14:54:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787081823,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 562348",
    },
    {
      SMSID: 716218,
      DateTime: "02/11/2021 14:58:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701795058,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 604897",
    },
    {
      SMSID: 716221,
      DateTime: "02/11/2021 15:00:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760201882,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 955810",
    },
    {
      SMSID: 716250,
      DateTime: "02/11/2021 15:27:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707484539,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 209263",
    },
    {
      SMSID: 716255,
      DateTime: "02/11/2021 15:34:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785794143,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 198795",
    },
    {
      SMSID: 716284,
      DateTime: "02/11/2021 15:59:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770922066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 819806",
    },
    {
      SMSID: 716285,
      DateTime: "02/11/2021 16:00:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770922066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 530243",
    },
    {
      SMSID: 716288,
      DateTime: "02/11/2021 16:03:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770922066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 900685",
    },
    {
      SMSID: 716289,
      DateTime: "02/11/2021 16:04:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770922066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 688148",
    },
    {
      SMSID: 716290,
      DateTime: "02/11/2021 16:05:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770922066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 403935",
    },
    {
      SMSID: 716291,
      DateTime: "02/11/2021 16:05:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770922066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 322740",
    },
    {
      SMSID: 716292,
      DateTime: "02/11/2021 16:05:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758352988,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 359367",
    },
    {
      SMSID: 716298,
      DateTime: "02/11/2021 16:23:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785784702,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 473367",
    },
    {
      SMSID: 716303,
      DateTime: "02/11/2021 16:33:58",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: "256O777252360",
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 953390",
    },
    {
      SMSID: 716304,
      DateTime: "02/11/2021 16:35:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777697274,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 518844",
    },
    {
      SMSID: 716305,
      DateTime: "02/11/2021 16:41:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760575605,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 496249",
    },
    {
      SMSID: 716306,
      DateTime: "02/11/2021 16:43:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740579185,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 382613",
    },
    {
      SMSID: 716307,
      DateTime: "02/11/2021 16:44:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781417289,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 875711",
    },
    {
      SMSID: 716310,
      DateTime: "02/11/2021 16:46:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740579185,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 117876",
    },
    {
      SMSID: 716311,
      DateTime: "02/11/2021 16:49:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740579185,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 778404",
    },
    {
      SMSID: 716314,
      DateTime: "02/11/2021 17:13:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756005997,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 810959",
    },
    {
      SMSID: 716316,
      DateTime: "02/11/2021 17:15:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756005997,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 924644",
    },
    {
      SMSID: 716321,
      DateTime: "02/11/2021 17:32:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785784702,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 409844",
    },
    {
      SMSID: 716322,
      DateTime: "02/11/2021 17:48:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID307056, has won and the payout UGX10250 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716326,
      DateTime: "02/11/2021 17:56:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778184933,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 122882",
    },
    {
      SMSID: 716330,
      DateTime: "02/11/2021 18:14:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775607068,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 556192",
    },
    {
      SMSID: 716338,
      DateTime: "02/11/2021 18:45:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760529030,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 170442",
    },
    {
      SMSID: 716341,
      DateTime: "02/11/2021 18:50:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703270297,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 980014",
    },
    {
      SMSID: 716347,
      DateTime: "02/11/2021 19:18:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID307075, has won and the payout UGX3445 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716348,
      DateTime: "02/11/2021 19:20:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777759828,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 737196",
    },
    {
      SMSID: 716365,
      DateTime: "02/11/2021 19:49:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774504924,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 267437",
    },
    {
      SMSID: 716366,
      DateTime: "02/11/2021 19:50:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774504024,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 922512",
    },
    {
      SMSID: 716372,
      DateTime: "02/11/2021 19:58:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779272097,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 842350",
    },
    {
      SMSID: 716377,
      DateTime: "02/11/2021 20:05:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788665824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 321998",
    },
    {
      SMSID: 716378,
      DateTime: "02/11/2021 20:06:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779272097,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 208275",
    },
    {
      SMSID: 716379,
      DateTime: "02/11/2021 20:07:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788665824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 396520",
    },
    {
      SMSID: 716380,
      DateTime: "02/11/2021 20:11:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788665824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 267121",
    },
    {
      SMSID: 716381,
      DateTime: "02/11/2021 20:14:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788665824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 186965",
    },
    {
      SMSID: 716382,
      DateTime: "02/11/2021 20:14:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779272097,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 502122",
    },
    {
      SMSID: 716383,
      DateTime: "02/11/2021 20:14:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788665824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 434687",
    },
    {
      SMSID: 716384,
      DateTime: "02/11/2021 20:15:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788665824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 766838",
    },
    {
      SMSID: 716385,
      DateTime: "02/11/2021 20:18:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701924547,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 142566",
    },
    {
      SMSID: 716395,
      DateTime: "02/11/2021 21:32:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775955875,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 898015",
    },
    {
      SMSID: 716396,
      DateTime: "02/11/2021 21:35:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774896991,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 786480",
    },
    {
      SMSID: 716399,
      DateTime: "02/11/2021 21:37:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773681859,
      Interface: "Shortcode",
      Message:
        "You won! BetID296932, has won and the payout UGX600 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716400,
      DateTime: "02/11/2021 21:45:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756628056,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 146373",
    },
    {
      SMSID: 716401,
      DateTime: "02/11/2021 21:51:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774896991,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 947378",
    },
    {
      SMSID: 716402,
      DateTime: "02/11/2021 21:56:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786842129,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 192737",
    },
    {
      SMSID: 716405,
      DateTime: "02/11/2021 22:06:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760583689,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 855116",
    },
    {
      SMSID: 716408,
      DateTime: "02/11/2021 22:14:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751649649,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 506016",
    },
    {
      SMSID: 716409,
      DateTime: "02/11/2021 22:53:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756472670,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 931123",
    },
    {
      SMSID: 716414,
      DateTime: "02/11/2021 23:12:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786450935,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 297575",
    },
    {
      SMSID: 716415,
      DateTime: "02/11/2021 23:45:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782132079,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 901620",
    },
    {
      SMSID: 716416,
      DateTime: "02/11/2021 23:46:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782132079,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 786454",
    },
    {
      SMSID: 716417,
      DateTime: "03/11/2021 00:21:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785418775,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 396965",
    },
    {
      SMSID: 716418,
      DateTime: "03/11/2021 00:24:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785418775,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 515897",
    },
    {
      SMSID: 716419,
      DateTime: "03/11/2021 00:33:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706594196,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 281233",
    },
    {
      SMSID: 716420,
      DateTime: "03/11/2021 02:20:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750873803,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 371983",
    },
    {
      SMSID: 716421,
      DateTime: "03/11/2021 02:21:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750873803,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 369844",
    },
    {
      SMSID: 716422,
      DateTime: "03/11/2021 02:22:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750873803,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 615117",
    },
    {
      SMSID: 716423,
      DateTime: "03/11/2021 02:30:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750873803,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 414527",
    },
    {
      SMSID: 716424,
      DateTime: "03/11/2021 02:52:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788935953,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 274736",
    },
    {
      SMSID: 716425,
      DateTime: "03/11/2021 02:57:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750873803,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 817143",
    },
    {
      SMSID: 716426,
      DateTime: "03/11/2021 02:58:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750873803,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 951784",
    },
    {
      SMSID: 716427,
      DateTime: "03/11/2021 05:07:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708730028,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 229549",
    },
    {
      SMSID: 716430,
      DateTime: "03/11/2021 05:42:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773092259,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 937687",
    },
    {
      SMSID: 716431,
      DateTime: "03/11/2021 05:50:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704265160,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 213833",
    },
    {
      SMSID: 716432,
      DateTime: "03/11/2021 06:04:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784947619,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 144351",
    },
    {
      SMSID: 716441,
      DateTime: "03/11/2021 06:35:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705760554,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 429124",
    },
    {
      SMSID: 716446,
      DateTime: "03/11/2021 07:27:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754928653,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 481268",
    },
    {
      SMSID: 716449,
      DateTime: "03/11/2021 08:15:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758506646,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 157340",
    },
    {
      SMSID: 716452,
      DateTime: "03/11/2021 09:04:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785418775,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 865136",
    },
    {
      SMSID: 716453,
      DateTime: "03/11/2021 09:05:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785418775,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 556129",
    },
    {
      SMSID: 716454,
      DateTime: "03/11/2021 09:06:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785418775,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 574946",
    },
    {
      SMSID: 716474,
      DateTime: "03/11/2021 09:44:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750929122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 484921",
    },
    {
      SMSID: 716493,
      DateTime: "03/11/2021 10:52:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774503838,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 730040",
    },
    {
      SMSID: 716494,
      DateTime: "03/11/2021 10:53:16",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774503838,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 293654",
    },
    {
      SMSID: 716508,
      DateTime: "03/11/2021 11:18:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752698621,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 934107",
    },
    {
      SMSID: 716509,
      DateTime: "03/11/2021 11:18:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752698621,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 287703",
    },
    {
      SMSID: 716512,
      DateTime: "03/11/2021 11:23:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753488241,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 587756",
    },
    {
      SMSID: 716513,
      DateTime: "03/11/2021 11:23:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704402573,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 862879",
    },
    {
      SMSID: 716514,
      DateTime: "03/11/2021 11:27:16",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753488241,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 434673",
    },
    {
      SMSID: 716515,
      DateTime: "03/11/2021 11:29:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753488241,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 114372",
    },
    {
      SMSID: 716516,
      DateTime: "03/11/2021 11:30:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753488241,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 210231",
    },
    {
      SMSID: 716525,
      DateTime: "03/11/2021 12:16:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778904311,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 241218",
    },
    {
      SMSID: 716528,
      DateTime: "03/11/2021 12:27:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705997326,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 680200",
    },
    {
      SMSID: 716529,
      DateTime: "03/11/2021 12:27:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705997326,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 409889",
    },
    {
      SMSID: 716530,
      DateTime: "03/11/2021 12:28:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705997326,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 312082",
    },
    {
      SMSID: 716541,
      DateTime: "03/11/2021 12:48:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775963523,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 497528",
    },
    {
      SMSID: 716542,
      DateTime: "03/11/2021 13:02:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754507361,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 488340",
    },
    {
      SMSID: 716543,
      DateTime: "03/11/2021 13:11:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779577565,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 317148",
    },
    {
      SMSID: 716544,
      DateTime: "03/11/2021 13:14:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779577565,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 861798",
    },
    {
      SMSID: 716545,
      DateTime: "03/11/2021 13:14:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753488241,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 805031",
    },
    {
      SMSID: 716546,
      DateTime: "03/11/2021 13:15:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753488241,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 662656",
    },
    {
      SMSID: 716547,
      DateTime: "03/11/2021 13:17:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756056876,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 264807",
    },
    {
      SMSID: 716548,
      DateTime: "03/11/2021 13:17:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779577565,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 816565",
    },
    {
      SMSID: 716553,
      DateTime: "03/11/2021 13:26:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702101675,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 674216",
    },
    {
      SMSID: 716566,
      DateTime: "03/11/2021 14:26:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754947871,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 339245",
    },
    {
      SMSID: 716569,
      DateTime: "03/11/2021 14:36:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256755612495,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 713503",
    },
    {
      SMSID: 716570,
      DateTime: "03/11/2021 14:37:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760932897,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 463451",
    },
    {
      SMSID: 716587,
      DateTime: "03/11/2021 15:23:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256761050349,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 943839",
    },
    {
      SMSID: 716588,
      DateTime: "03/11/2021 15:26:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256761050349,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 787022",
    },
    {
      SMSID: 716593,
      DateTime: "03/11/2021 15:40:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256761050349,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 336461",
    },
    {
      SMSID: 716627,
      DateTime: "03/11/2021 16:17:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773555806,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 860383",
    },
    {
      SMSID: 716628,
      DateTime: "03/11/2021 16:18:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770611824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 173564",
    },
    {
      SMSID: 716629,
      DateTime: "03/11/2021 16:18:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773555806,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 362174",
    },
    {
      SMSID: 716638,
      DateTime: "03/11/2021 16:24:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786449861,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 631750",
    },
    {
      SMSID: 716639,
      DateTime: "03/11/2021 16:26:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786449861,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 478460",
    },
    {
      SMSID: 716642,
      DateTime: "03/11/2021 16:45:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786449861,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 982575",
    },
    {
      SMSID: 716643,
      DateTime: "03/11/2021 16:46:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786449861,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 279856",
    },
    {
      SMSID: 716655,
      DateTime: "03/11/2021 17:04:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702786431,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 731619",
    },
    {
      SMSID: 716656,
      DateTime: "03/11/2021 17:06:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784059297,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 387113",
    },
    {
      SMSID: 716673,
      DateTime: "03/11/2021 17:22:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706356314,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 418182",
    },
    {
      SMSID: 716680,
      DateTime: "03/11/2021 17:51:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779186174,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 511286",
    },
    {
      SMSID: 716688,
      DateTime: "03/11/2021 18:28:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789197607,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 613087",
    },
    {
      SMSID: 716695,
      DateTime: "03/11/2021 18:42:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID307219, has won and the payout UGX12000 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716696,
      DateTime: "03/11/2021 18:44:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777749717,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 379631",
    },
    {
      SMSID: 716699,
      DateTime: "03/11/2021 18:45:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777749717,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 197918",
    },
    {
      SMSID: 716700,
      DateTime: "03/11/2021 18:46:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777749717,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 229123",
    },
    {
      SMSID: 716705,
      DateTime: "03/11/2021 18:54:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779499745,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 879985",
    },
    {
      SMSID: 716730,
      DateTime: "03/11/2021 19:21:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID307223, has won and the payout UGX5740 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716796,
      DateTime: "03/11/2021 19:56:50",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID307229, has won and the payout UGX8000 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716799,
      DateTime: "03/11/2021 19:59:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773891669,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 795702",
    },
    {
      SMSID: 716805,
      DateTime: "03/11/2021 20:02:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773891669,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 924867",
    },
    {
      SMSID: 716806,
      DateTime: "03/11/2021 20:03:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775522464,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 747568",
    },
    {
      SMSID: 716807,
      DateTime: "03/11/2021 20:11:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773891669,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 181951",
    },
    {
      SMSID: 716842,
      DateTime: "03/11/2021 20:45:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778882900,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 125587",
    },
    {
      SMSID: 716845,
      DateTime: "03/11/2021 20:47:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778882900,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 538132",
    },
    {
      SMSID: 716851,
      DateTime: "03/11/2021 20:51:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704810927,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 354747",
    },
    {
      SMSID: 716864,
      DateTime: "03/11/2021 20:55:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779097284,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 189102",
    },
    {
      SMSID: 716871,
      DateTime: "03/11/2021 20:56:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781979417,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 539634",
    },
    {
      SMSID: 716891,
      DateTime: "03/11/2021 21:13:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID307233, has won and the payout UGX10250 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716905,
      DateTime: "03/11/2021 21:40:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID307267, has won and the payout UGX7200 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716906,
      DateTime: "03/11/2021 21:51:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701160666,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 690260",
    },
    {
      SMSID: 716907,
      DateTime: "03/11/2021 21:52:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701015212,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 224769",
    },
    {
      SMSID: 716937,
      DateTime: "03/11/2021 22:57:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779379016,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 980627",
    },
    {
      SMSID: 716946,
      DateTime: "03/11/2021 23:26:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703270297,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 598563",
    },
    {
      SMSID: 716947,
      DateTime: "03/11/2021 23:49:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256778108928,
      Interface: "Shortcode",
      Message:
        "You won! BetID307084, has won and the payout UGX655 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716948,
      DateTime: "03/11/2021 23:57:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773681859,
      Interface: "Shortcode",
      Message:
        "You won! BetID307230, has won and the payout UGX2190 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 716959,
      DateTime: "04/11/2021 04:40:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773555806,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 101123",
    },
    {
      SMSID: 716962,
      DateTime: "04/11/2021 06:32:16",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778813956,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 432503",
    },
    {
      SMSID: 716975,
      DateTime: "04/11/2021 08:43:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778790645,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 794549",
    },
    {
      SMSID: 716977,
      DateTime: "04/11/2021 08:44:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786236664,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 492422",
    },
    {
      SMSID: 716981,
      DateTime: "04/11/2021 09:00:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773215625,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 436788",
    },
    {
      SMSID: 717012,
      DateTime: "04/11/2021 10:16:50",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703323719,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 389017",
    },
    {
      SMSID: 717013,
      DateTime: "04/11/2021 10:18:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703323719,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 106334",
    },
    {
      SMSID: 717014,
      DateTime: "04/11/2021 10:18:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703323719,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 668325",
    },
    {
      SMSID: 717015,
      DateTime: "04/11/2021 10:19:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772441539,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 926977",
    },
    {
      SMSID: 717020,
      DateTime: "04/11/2021 10:39:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771822227,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 970778",
    },
    {
      SMSID: 717021,
      DateTime: "04/11/2021 10:40:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771822227,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 345156",
    },
    {
      SMSID: 717022,
      DateTime: "04/11/2021 10:40:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771822227,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 997378",
    },
    {
      SMSID: 717030,
      DateTime: "04/11/2021 11:43:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701224917,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 901768",
    },
    {
      SMSID: 717038,
      DateTime: "04/11/2021 12:43:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771260674,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 483516",
    },
    {
      SMSID: 717041,
      DateTime: "04/11/2021 13:19:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756483803,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 124520",
    },
    {
      SMSID: 717044,
      DateTime: "04/11/2021 13:22:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756483803,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 302374",
    },
    {
      SMSID: 717047,
      DateTime: "04/11/2021 13:35:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785553504,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 139047",
    },
    {
      SMSID: 717048,
      DateTime: "04/11/2021 13:41:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778334195,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 319018",
    },
    {
      SMSID: 717049,
      DateTime: "04/11/2021 13:41:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750589760,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 241922",
    },
    {
      SMSID: 717050,
      DateTime: "04/11/2021 13:42:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750589760,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 142481",
    },
    {
      SMSID: 717098,
      DateTime: "04/11/2021 16:44:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786327800,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 519663",
    },
    {
      SMSID: 717101,
      DateTime: "04/11/2021 17:00:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785553504,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 687877",
    },
    {
      SMSID: 717130,
      DateTime: "04/11/2021 18:31:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708276780,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 176096",
    },
    {
      SMSID: 717131,
      DateTime: "04/11/2021 18:32:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708276780,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 529409",
    },
    {
      SMSID: 717137,
      DateTime: "04/11/2021 18:58:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708323007,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 699987",
    },
    {
      SMSID: 717161,
      DateTime: "04/11/2021 20:05:58",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760332466,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 463301",
    },
    {
      SMSID: 717162,
      DateTime: "04/11/2021 20:22:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701725671,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 708002",
    },
    {
      SMSID: 717163,
      DateTime: "04/11/2021 20:26:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750873803,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 416316",
    },
    {
      SMSID: 717164,
      DateTime: "04/11/2021 20:30:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760477076,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 746098",
    },
    {
      SMSID: 717168,
      DateTime: "04/11/2021 21:41:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256779186174,
      Interface: "Shortcode",
      Message:
        "You won! BetID307390, has won and the payout UGX550 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717169,
      DateTime: "04/11/2021 21:41:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256774075244,
      Interface: "Shortcode",
      Message:
        "You won! BetID307388, has won and the payout UGX695 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717173,
      DateTime: "04/11/2021 22:22:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703738472,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 304788",
    },
    {
      SMSID: 717174,
      DateTime: "04/11/2021 22:28:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703738472,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 666299",
    },
    {
      SMSID: 717175,
      DateTime: "04/11/2021 23:42:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772545857,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 449274",
    },
    {
      SMSID: 717179,
      DateTime: "05/11/2021 02:04:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760529030,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 864809",
    },
    {
      SMSID: 717191,
      DateTime: "05/11/2021 05:55:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706058890,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 117903",
    },
    {
      SMSID: 717194,
      DateTime: "05/11/2021 06:56:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782329418,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 979096",
    },
    {
      SMSID: 717195,
      DateTime: "05/11/2021 07:49:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782329418,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 121214",
    },
    {
      SMSID: 717216,
      DateTime: "05/11/2021 10:08:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787958125,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 990287",
    },
    {
      SMSID: 717217,
      DateTime: "05/11/2021 10:08:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787958125,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 250419",
    },
    {
      SMSID: 717218,
      DateTime: "05/11/2021 10:09:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787958125,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 247273",
    },
    {
      SMSID: 717219,
      DateTime: "05/11/2021 10:12:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787958125,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 879704",
    },
    {
      SMSID: 717231,
      DateTime: "05/11/2021 10:45:58",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703277416,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 382142",
    },
    {
      SMSID: 717232,
      DateTime: "05/11/2021 10:48:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706775856,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 273247",
    },
    {
      SMSID: 717233,
      DateTime: "05/11/2021 10:50:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706775856,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 291073",
    },
    {
      SMSID: 717234,
      DateTime: "05/11/2021 10:50:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772987708,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 275799",
    },
    {
      SMSID: 717237,
      DateTime: "05/11/2021 11:47:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775301909,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 869082",
    },
    {
      SMSID: 717238,
      DateTime: "05/11/2021 11:47:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775301909,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 714318",
    },
    {
      SMSID: 717239,
      DateTime: "05/11/2021 11:52:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707242780,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 681474",
    },
    {
      SMSID: 717240,
      DateTime: "05/11/2021 11:53:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707242780,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 542886",
    },
    {
      SMSID: 717241,
      DateTime: "05/11/2021 11:53:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707242780,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 682758",
    },
    {
      SMSID: 717249,
      DateTime: "05/11/2021 12:11:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781552046,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 961305",
    },
    {
      SMSID: 717265,
      DateTime: "05/11/2021 14:06:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783694154,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 689891",
    },
    {
      SMSID: 717268,
      DateTime: "05/11/2021 14:51:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771327693,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 612820",
    },
    {
      SMSID: 717274,
      DateTime: "05/11/2021 15:30:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701864607,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 381791",
    },
    {
      SMSID: 717278,
      DateTime: "05/11/2021 16:21:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760091620,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 593184",
    },
    {
      SMSID: 717281,
      DateTime: "05/11/2021 17:17:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256755756702,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 538970",
    },
    {
      SMSID: 717282,
      DateTime: "05/11/2021 17:18:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760016957,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 772686",
    },
    {
      SMSID: 717302,
      DateTime: "05/11/2021 18:51:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773681859,
      Interface: "Shortcode",
      Message:
        "You won! BetID317430, has won and the payout UGX868 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717303,
      DateTime: "05/11/2021 18:52:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787764295,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 345747",
    },
    {
      SMSID: 717304,
      DateTime: "05/11/2021 18:54:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771553337,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 646654",
    },
    {
      SMSID: 717315,
      DateTime: "05/11/2021 19:36:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID317452, has won and the payout UGX3722 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717326,
      DateTime: "05/11/2021 19:56:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786669558,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 757066",
    },
    {
      SMSID: 717327,
      DateTime: "05/11/2021 19:58:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773681859,
      Interface: "Shortcode",
      Message:
        "You won! BetID317450, has won and the payout UGX1005 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717328,
      DateTime: "05/11/2021 20:16:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256709478010,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 259847",
    },
    {
      SMSID: 717383,
      DateTime: "05/11/2021 20:46:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708604299,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 862487",
    },
    {
      SMSID: 717507,
      DateTime: "05/11/2021 22:14:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770922066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 935324",
    },
    {
      SMSID: 717512,
      DateTime: "05/11/2021 22:33:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785356212,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 799915",
    },
    {
      SMSID: 717517,
      DateTime: "05/11/2021 22:42:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256755462649,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 801853",
    },
    {
      SMSID: 717518,
      DateTime: "05/11/2021 22:48:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773681859,
      Interface: "Shortcode",
      Message:
        "You won! BetID317457, has won and the payout UGX745 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717526,
      DateTime: "05/11/2021 22:58:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771237316,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 503743",
    },
    {
      SMSID: 717527,
      DateTime: "05/11/2021 22:59:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787764295,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 459000",
    },
    {
      SMSID: 717528,
      DateTime: "05/11/2021 23:02:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770922066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 849512",
    },
    {
      SMSID: 717529,
      DateTime: "05/11/2021 23:03:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770922066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 315770",
    },
    {
      SMSID: 717530,
      DateTime: "05/11/2021 23:04:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750954936,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 826052",
    },
    {
      SMSID: 717531,
      DateTime: "05/11/2021 23:05:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771237316,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 380701",
    },
    {
      SMSID: 717532,
      DateTime: "05/11/2021 23:10:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775179586,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 417132",
    },
    {
      SMSID: 717533,
      DateTime: "05/11/2021 23:16:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770922066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 261181",
    },
    {
      SMSID: 717534,
      DateTime: "05/11/2021 23:32:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778703452,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 650968",
    },
    {
      SMSID: 717535,
      DateTime: "05/11/2021 23:33:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778703452,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 767608",
    },
    {
      SMSID: 717538,
      DateTime: "06/11/2021 01:53:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773681859,
      Interface: "Shortcode",
      Message:
        "You won! BetID317451, has won and the payout UGX1740 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717539,
      DateTime: "06/11/2021 05:19:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700322605,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 645499",
    },
    {
      SMSID: 717540,
      DateTime: "06/11/2021 05:20:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700322605,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 315259",
    },
    {
      SMSID: 717541,
      DateTime: "06/11/2021 05:21:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700322605,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 706190",
    },
    {
      SMSID: 717544,
      DateTime: "06/11/2021 06:36:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787890744,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 411132",
    },
    {
      SMSID: 717545,
      DateTime: "06/11/2021 06:42:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783984471,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 783692",
    },
    {
      SMSID: 717560,
      DateTime: "06/11/2021 08:28:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779836551,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 668578",
    },
    {
      SMSID: 717567,
      DateTime: "06/11/2021 08:52:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703939796,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 997718",
    },
    {
      SMSID: 717568,
      DateTime: "06/11/2021 08:59:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777566230,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 826874",
    },
    {
      SMSID: 717571,
      DateTime: "06/11/2021 09:05:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777566230,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 565141",
    },
    {
      SMSID: 717572,
      DateTime: "06/11/2021 09:08:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751808284,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 517373",
    },
    {
      SMSID: 717573,
      DateTime: "06/11/2021 09:15:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787390312,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 995905",
    },
    {
      SMSID: 717574,
      DateTime: "06/11/2021 09:15:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787390312,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 441626",
    },
    {
      SMSID: 717575,
      DateTime: "06/11/2021 09:15:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787390312,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 305558",
    },
    {
      SMSID: 717576,
      DateTime: "06/11/2021 09:16:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787390312,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 746756",
    },
    {
      SMSID: 717577,
      DateTime: "06/11/2021 09:16:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787390312,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 891043",
    },
    {
      SMSID: 717578,
      DateTime: "06/11/2021 09:17:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751808284,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 135085",
    },
    {
      SMSID: 717579,
      DateTime: "06/11/2021 09:29:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785004736,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 140599",
    },
    {
      SMSID: 717584,
      DateTime: "06/11/2021 10:23:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706265678,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 456832",
    },
    {
      SMSID: 717585,
      DateTime: "06/11/2021 10:24:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706265678,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 980129",
    },
    {
      SMSID: 717587,
      DateTime: "06/11/2021 10:32:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786235414,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 506952",
    },
    {
      SMSID: 717591,
      DateTime: "06/11/2021 10:58:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778790645,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 975925",
    },
    {
      SMSID: 717592,
      DateTime: "06/11/2021 10:59:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778790645,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 668100",
    },
    {
      SMSID: 717593,
      DateTime: "06/11/2021 11:00:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778790645,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 426649",
    },
    {
      SMSID: 717594,
      DateTime: "06/11/2021 11:01:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778790645,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 298104",
    },
    {
      SMSID: 717602,
      DateTime: "06/11/2021 11:41:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID317462, has won and the payout UGX4915 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717611,
      DateTime: "06/11/2021 12:05:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703738472,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 347422",
    },
    {
      SMSID: 717612,
      DateTime: "06/11/2021 12:06:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703738472,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 866288",
    },
    {
      SMSID: 717613,
      DateTime: "06/11/2021 12:09:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754733859,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 900046",
    },
    {
      SMSID: 717614,
      DateTime: "06/11/2021 12:40:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771362128,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 296686",
    },
    {
      SMSID: 717619,
      DateTime: "06/11/2021 12:54:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771362128,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 427805",
    },
    {
      SMSID: 717620,
      DateTime: "06/11/2021 13:06:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700646688,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 693794",
    },
    {
      SMSID: 717629,
      DateTime: "06/11/2021 13:30:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758210301,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 395782",
    },
    {
      SMSID: 717633,
      DateTime: "06/11/2021 13:40:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778703452,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 941101",
    },
    {
      SMSID: 717634,
      DateTime: "06/11/2021 13:42:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778703452,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 865915",
    },
    {
      SMSID: 717638,
      DateTime: "06/11/2021 13:48:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783141902,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 994732",
    },
    {
      SMSID: 717683,
      DateTime: "06/11/2021 15:04:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760066761,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 739654",
    },
    {
      SMSID: 717706,
      DateTime: "06/11/2021 16:19:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785231601,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 866265",
    },
    {
      SMSID: 717707,
      DateTime: "06/11/2021 16:25:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787910572,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 688525",
    },
    {
      SMSID: 717733,
      DateTime: "06/11/2021 17:20:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760814032,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 496332",
    },
    {
      SMSID: 717744,
      DateTime: "06/11/2021 17:43:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778141095,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 519089",
    },
    {
      SMSID: 717745,
      DateTime: "06/11/2021 17:47:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778141095,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 191348",
    },
    {
      SMSID: 717752,
      DateTime: "06/11/2021 18:03:41",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784149464,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 615868",
    },
    {
      SMSID: 717762,
      DateTime: "06/11/2021 18:18:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788371911,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 187286",
    },
    {
      SMSID: 717777,
      DateTime: "06/11/2021 18:35:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785139491,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 528542",
    },
    {
      SMSID: 717782,
      DateTime: "06/11/2021 18:40:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771181711,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 242120",
    },
    {
      SMSID: 717783,
      DateTime: "06/11/2021 18:41:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID317887, has won and the payout UGX17500 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717786,
      DateTime: "06/11/2021 18:46:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752111537,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 465788",
    },
    {
      SMSID: 717799,
      DateTime: "06/11/2021 19:11:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID317894, has won and the payout UGX20000 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717802,
      DateTime: "06/11/2021 19:21:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780478378,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 560781",
    },
    {
      SMSID: 717835,
      DateTime: "06/11/2021 20:44:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256754678566,
      Interface: "Shortcode",
      Message:
        "You won! BetID317364, has won and the payout UGX2856 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717844,
      DateTime: "06/11/2021 20:54:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID317904, has won and the payout UGX26000 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717849,
      DateTime: "06/11/2021 21:24:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707033021,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 295213",
    },
    {
      SMSID: 717850,
      DateTime: "06/11/2021 21:25:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707033021,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 278932",
    },
    {
      SMSID: 717851,
      DateTime: "06/11/2021 21:26:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707033021,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 883234",
    },
    {
      SMSID: 717854,
      DateTime: "06/11/2021 21:27:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708756195,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 102586",
    },
    {
      SMSID: 717855,
      DateTime: "06/11/2021 21:41:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776138403,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 351859",
    },
    {
      SMSID: 717864,
      DateTime: "06/11/2021 22:13:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753773770,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 387984",
    },
    {
      SMSID: 717865,
      DateTime: "06/11/2021 22:14:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753773770,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 865237",
    },
    {
      SMSID: 717866,
      DateTime: "06/11/2021 22:39:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770744178,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 294775",
    },
    {
      SMSID: 717867,
      DateTime: "06/11/2021 22:40:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256784209045,
      Interface: "Shortcode",
      Message:
        "You won! BetID317859, has won and the payout UGX33432 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717874,
      DateTime: "06/11/2021 23:19:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760808202,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 224591",
    },
    {
      SMSID: 717875,
      DateTime: "06/11/2021 23:20:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760808202,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 492659",
    },
    {
      SMSID: 717876,
      DateTime: "06/11/2021 23:21:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760808202,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 856118",
    },
    {
      SMSID: 717879,
      DateTime: "06/11/2021 23:52:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256774075244,
      Interface: "Shortcode",
      Message:
        "You won! BetID317905, has won and the payout UGX690 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 717885,
      DateTime: "07/11/2021 05:13:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750165447,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 673399",
    },
    {
      SMSID: 717895,
      DateTime: "07/11/2021 07:44:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256757306824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 954489",
    },
    {
      SMSID: 717896,
      DateTime: "07/11/2021 07:44:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772399171,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 302838",
    },
    {
      SMSID: 717897,
      DateTime: "07/11/2021 08:02:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770465444,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 865978",
    },
    {
      SMSID: 717898,
      DateTime: "07/11/2021 08:07:50",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778202530,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 969218",
    },
    {
      SMSID: 717908,
      DateTime: "07/11/2021 09:01:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773993399,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 560111",
    },
    {
      SMSID: 717909,
      DateTime: "07/11/2021 09:02:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701072518,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 836763",
    },
    {
      SMSID: 717910,
      DateTime: "07/11/2021 09:06:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773993399,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 977936",
    },
    {
      SMSID: 717913,
      DateTime: "07/11/2021 09:45:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772152976,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 805323",
    },
    {
      SMSID: 717916,
      DateTime: "07/11/2021 10:00:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787406113,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 531070",
    },
    {
      SMSID: 717917,
      DateTime: "07/11/2021 10:07:41",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704895209,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 105815",
    },
    {
      SMSID: 717923,
      DateTime: "07/11/2021 10:43:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752593877,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 349731",
    },
    {
      SMSID: 717925,
      DateTime: "07/11/2021 11:25:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776145499,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 709902",
    },
    {
      SMSID: 717926,
      DateTime: "07/11/2021 11:26:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706061142,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 443379",
    },
    {
      SMSID: 717927,
      DateTime: "07/11/2021 11:27:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776145499,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 914133",
    },
    {
      SMSID: 717928,
      DateTime: "07/11/2021 12:02:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772366044,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 707555",
    },
    {
      SMSID: 717931,
      DateTime: "07/11/2021 12:05:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772366044,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 838494",
    },
    {
      SMSID: 717939,
      DateTime: "07/11/2021 12:18:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772366044,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 364686",
    },
    {
      SMSID: 717954,
      DateTime: "07/11/2021 12:46:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750995608,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 669060",
    },
    {
      SMSID: 717957,
      DateTime: "07/11/2021 12:47:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750995608,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 983972",
    },
    {
      SMSID: 717958,
      DateTime: "07/11/2021 12:48:58",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750995608,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 521834",
    },
    {
      SMSID: 717960,
      DateTime: "07/11/2021 12:50:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750995608,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 734840",
    },
    {
      SMSID: 717961,
      DateTime: "07/11/2021 12:50:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703953428,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 638736",
    },
    {
      SMSID: 717978,
      DateTime: "07/11/2021 13:05:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760837613,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 405976",
    },
    {
      SMSID: 717979,
      DateTime: "07/11/2021 13:08:50",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758217742,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 561726",
    },
    {
      SMSID: 718000,
      DateTime: "07/11/2021 13:48:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID318333, has won and the payout UGX11500 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 718003,
      DateTime: "07/11/2021 13:53:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706351607,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 731997",
    },
    {
      SMSID: 718015,
      DateTime: "07/11/2021 14:33:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740571932,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 897842",
    },
    {
      SMSID: 718082,
      DateTime: "07/11/2021 15:28:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752569122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 657102",
    },
    {
      SMSID: 718128,
      DateTime: "07/11/2021 15:54:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779110756,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 689673",
    },
    {
      SMSID: 718129,
      DateTime: "07/11/2021 15:57:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779110756,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 461252",
    },
    {
      SMSID: 718135,
      DateTime: "07/11/2021 16:36:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752088866,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 933775",
    },
    {
      SMSID: 718136,
      DateTime: "07/11/2021 16:36:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752088866,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 633091",
    },
    {
      SMSID: 718141,
      DateTime: "07/11/2021 16:55:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759835208,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 890125",
    },
    {
      SMSID: 718142,
      DateTime: "07/11/2021 16:56:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID318533, has won and the payout UGX11400 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 718143,
      DateTime: "07/11/2021 16:56:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760734650,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 943294",
    },
    {
      SMSID: 718144,
      DateTime: "07/11/2021 16:59:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780830324,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 158961",
    },
    {
      SMSID: 718153,
      DateTime: "07/11/2021 17:57:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773681859,
      Interface: "Shortcode",
      Message:
        "You won! BetID318322, has won and the payout UGX720 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 718154,
      DateTime: "07/11/2021 17:57:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256750165447,
      Interface: "Shortcode",
      Message:
        "You won! BetID318320, has won and the payout UGX720 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 718155,
      DateTime: "07/11/2021 18:00:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760159061,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 267098",
    },
    {
      SMSID: 718156,
      DateTime: "07/11/2021 18:02:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760159061,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 875204",
    },
    {
      SMSID: 718159,
      DateTime: "07/11/2021 18:21:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID318542, has won and the payout UGX5400 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 718167,
      DateTime: "07/11/2021 20:04:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256784209045,
      Interface: "Shortcode",
      Message:
        "You won! BetID318318, has won and the payout UGX29612 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 718208,
      DateTime: "07/11/2021 20:48:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760163207,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 713500",
    },
    {
      SMSID: 718280,
      DateTime: "07/11/2021 23:52:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256750165447,
      Interface: "Shortcode",
      Message:
        "You won! BetID318553, has won and the payout UGX1325 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 718310,
      DateTime: "08/11/2021 06:32:16",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758258398,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 985581",
    },
    {
      SMSID: 718322,
      DateTime: "08/11/2021 09:17:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760216843,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 625155",
    },
    {
      SMSID: 718345,
      DateTime: "08/11/2021 10:28:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779920599,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 538242",
    },
    {
      SMSID: 718346,
      DateTime: "08/11/2021 10:32:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701844456,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 843961",
    },
    {
      SMSID: 718347,
      DateTime: "08/11/2021 10:48:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789362231,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 157577",
    },
    {
      SMSID: 718348,
      DateTime: "08/11/2021 10:49:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789362231,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 204698",
    },
    {
      SMSID: 718351,
      DateTime: "08/11/2021 10:50:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750193647,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 577454",
    },
    {
      SMSID: 718354,
      DateTime: "08/11/2021 10:54:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780362231,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 242277",
    },
    {
      SMSID: 718359,
      DateTime: "08/11/2021 10:58:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789082140,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 506764",
    },
    {
      SMSID: 718378,
      DateTime: "08/11/2021 11:55:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772000710,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 659246",
    },
    {
      SMSID: 718381,
      DateTime: "08/11/2021 12:00:41",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788763166,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 772964",
    },
    {
      SMSID: 718472,
      DateTime: "08/11/2021 16:46:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740714695,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 388214",
    },
    {
      SMSID: 718507,
      DateTime: "08/11/2021 18:07:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771165725,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 313837",
    },
    {
      SMSID: 718546,
      DateTime: "08/11/2021 19:22:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773681859,
      Interface: "Shortcode",
      Message:
        "You won! BetID318651, has won and the payout UGX740 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 718603,
      DateTime: "08/11/2021 20:43:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784377540,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 463704",
    },
    {
      SMSID: 718608,
      DateTime: "08/11/2021 20:49:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784377540,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 644056",
    },
    {
      SMSID: 718661,
      DateTime: "08/11/2021 22:25:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785048667,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 911855",
    },
    {
      SMSID: 718674,
      DateTime: "09/11/2021 06:07:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750080934,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 105819",
    },
    {
      SMSID: 718675,
      DateTime: "09/11/2021 06:28:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256755081182,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 845109",
    },
    {
      SMSID: 718678,
      DateTime: "09/11/2021 08:00:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787188938,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 118340",
    },
    {
      SMSID: 718679,
      DateTime: "09/11/2021 08:07:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753524358,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 900022",
    },
    {
      SMSID: 718680,
      DateTime: "09/11/2021 08:10:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753524358,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 372169",
    },
    {
      SMSID: 718681,
      DateTime: "09/11/2021 08:12:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777151291,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 150803",
    },
    {
      SMSID: 718684,
      DateTime: "09/11/2021 08:24:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787188938,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 784736",
    },
    {
      SMSID: 718685,
      DateTime: "09/11/2021 08:26:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787188938,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 447181",
    },
    {
      SMSID: 718707,
      DateTime: "09/11/2021 09:35:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750028250,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 802876",
    },
    {
      SMSID: 718731,
      DateTime: "09/11/2021 11:18:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256771327693,
      Interface: "Shortcode",
      Message:
        "You won! BetID318672, has won and the payout UGX535 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 718734,
      DateTime: "09/11/2021 11:41:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785841710,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 505961",
    },
    {
      SMSID: 718735,
      DateTime: "09/11/2021 12:23:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786618695,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 518327",
    },
    {
      SMSID: 718742,
      DateTime: "09/11/2021 12:59:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787390075,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 323511",
    },
    {
      SMSID: 718743,
      DateTime: "09/11/2021 12:59:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787390075,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 817496",
    },
    {
      SMSID: 718744,
      DateTime: "09/11/2021 13:00:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787390075,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 504615",
    },
    {
      SMSID: 718748,
      DateTime: "09/11/2021 13:10:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700149952,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 492999",
    },
    {
      SMSID: 718757,
      DateTime: "09/11/2021 13:52:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704647749,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 441282",
    },
    {
      SMSID: 718793,
      DateTime: "09/11/2021 14:52:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776582036,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 221683",
    },
    {
      SMSID: 718802,
      DateTime: "09/11/2021 15:13:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783502399,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 140085",
    },
    {
      SMSID: 718865,
      DateTime: "09/11/2021 16:33:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752845193,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 861019",
    },
    {
      SMSID: 718878,
      DateTime: "09/11/2021 17:06:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701232798,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 969010",
    },
    {
      SMSID: 718879,
      DateTime: "09/11/2021 17:08:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701232798,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 489133",
    },
    {
      SMSID: 718900,
      DateTime: "09/11/2021 17:43:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700392936,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 829137",
    },
    {
      SMSID: 718901,
      DateTime: "09/11/2021 17:58:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700403073,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 800522",
    },
    {
      SMSID: 718910,
      DateTime: "09/11/2021 18:31:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777340142,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 431085",
    },
    {
      SMSID: 718984,
      DateTime: "09/11/2021 20:25:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701054452,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 497782",
    },
    {
      SMSID: 719036,
      DateTime: "09/11/2021 20:59:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750594049,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 401645",
    },
    {
      SMSID: 719050,
      DateTime: "09/11/2021 22:07:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784460206,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 544335",
    },
    {
      SMSID: 719066,
      DateTime: "09/11/2021 23:20:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773681859,
      Interface: "Shortcode",
      Message:
        "You won! BetID318681, has won and the payout UGX949 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 719069,
      DateTime: "10/11/2021 00:43:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783859931,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 765806",
    },
    {
      SMSID: 719083,
      DateTime: "10/11/2021 07:00:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772286502,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 763662",
    },
    {
      SMSID: 719084,
      DateTime: "10/11/2021 07:02:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772286502,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 348193",
    },
    {
      SMSID: 719091,
      DateTime: "10/11/2021 07:53:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777408550,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 822582",
    },
    {
      SMSID: 719096,
      DateTime: "10/11/2021 08:32:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751221350,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 792344",
    },
    {
      SMSID: 719100,
      DateTime: "10/11/2021 08:37:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705990072,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 542793",
    },
    {
      SMSID: 719107,
      DateTime: "10/11/2021 09:22:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756279950,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 214925",
    },
    {
      SMSID: 719112,
      DateTime: "10/11/2021 10:45:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703013446,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 628432",
    },
    {
      SMSID: 719118,
      DateTime: "10/11/2021 11:24:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703074947,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 927253",
    },
    {
      SMSID: 719120,
      DateTime: "10/11/2021 11:55:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759791358,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 984318",
    },
    {
      SMSID: 719125,
      DateTime: "10/11/2021 12:12:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771499830,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 354717",
    },
    {
      SMSID: 719134,
      DateTime: "10/11/2021 13:14:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705249427,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 549192",
    },
    {
      SMSID: 719135,
      DateTime: "10/11/2021 13:15:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705249427,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 543961",
    },
    {
      SMSID: 719136,
      DateTime: "10/11/2021 13:17:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705249427,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 971970",
    },
    {
      SMSID: 719137,
      DateTime: "10/11/2021 13:17:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705249427,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 246195",
    },
    {
      SMSID: 719155,
      DateTime: "10/11/2021 15:06:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771223482,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 896488",
    },
    {
      SMSID: 719168,
      DateTime: "10/11/2021 15:21:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760053321,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 761030",
    },
    {
      SMSID: 719189,
      DateTime: "10/11/2021 17:04:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740908709,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 352640",
    },
    {
      SMSID: 719207,
      DateTime: "10/11/2021 18:27:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256723830982,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 626726",
    },
    {
      SMSID: 719211,
      DateTime: "10/11/2021 18:56:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760414202,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 690274",
    },
    {
      SMSID: 719262,
      DateTime: "10/11/2021 20:21:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786635199,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 660095",
    },
    {
      SMSID: 719339,
      DateTime: "10/11/2021 21:33:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760298541,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 842242",
    },
    {
      SMSID: 719340,
      DateTime: "10/11/2021 21:42:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: "256 10752882169",
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 895698",
    },
    {
      SMSID: 719341,
      DateTime: "10/11/2021 22:07:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776807706,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 125191",
    },
    {
      SMSID: 719342,
      DateTime: "10/11/2021 23:38:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779058136,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 691039",
    },
    {
      SMSID: 719343,
      DateTime: "10/11/2021 23:39:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779058136,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 331504",
    },
    {
      SMSID: 719344,
      DateTime: "10/11/2021 23:42:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779058136,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 572689",
    },
    {
      SMSID: 719373,
      DateTime: "11/11/2021 11:00:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788665824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 554855",
    },
    {
      SMSID: 719381,
      DateTime: "11/11/2021 11:28:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778591358,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 271676",
    },
    {
      SMSID: 719382,
      DateTime: "11/11/2021 11:29:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778591358,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 970258",
    },
    {
      SMSID: 719383,
      DateTime: "11/11/2021 12:36:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784703901,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 802014",
    },
    {
      SMSID: 719392,
      DateTime: "11/11/2021 13:23:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256709672399,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 176745",
    },
    {
      SMSID: 719395,
      DateTime: "11/11/2021 13:34:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256709672399,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 108118",
    },
    {
      SMSID: 719397,
      DateTime: "11/11/2021 13:54:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256750149520,
      Interface: "Shortcode",
      Message:
        "You won! BetID318755, has won and the payout UGX1306 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 719398,
      DateTime: "11/11/2021 13:54:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256750149520,
      Interface: "Shortcode",
      Message:
        "You won! BetID318754, has won and the payout UGX1501 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 719419,
      DateTime: "11/11/2021 14:51:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256750149520,
      Interface: "Shortcode",
      Message:
        "You won! BetID318763, has won and the payout UGX2020 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 719428,
      DateTime: "11/11/2021 15:08:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256750149520,
      Interface: "Shortcode",
      Message:
        "You won! BetID318766, has won and the payout UGX1120 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 719429,
      DateTime: "11/11/2021 15:23:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776381056,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 778931",
    },
    {
      SMSID: 719430,
      DateTime: "11/11/2021 15:36:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752025772,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 341559",
    },
    {
      SMSID: 719434,
      DateTime: "11/11/2021 15:54:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256750149520,
      Interface: "Shortcode",
      Message:
        "You won! BetID318778, has won and the payout UGX2193 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 719444,
      DateTime: "11/11/2021 16:49:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID318793, has won and the payout UGX2200 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 719468,
      DateTime: "11/11/2021 18:25:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703722036,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 474715",
    },
    {
      SMSID: 719477,
      DateTime: "11/11/2021 18:53:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700455366,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 463741",
    },
    {
      SMSID: 719478,
      DateTime: "11/11/2021 18:53:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700455366,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 712541",
    },
    {
      SMSID: 719479,
      DateTime: "11/11/2021 18:56:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700455366,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 212089",
    },
    {
      SMSID: 719484,
      DateTime: "11/11/2021 18:57:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700455366,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 953100",
    },
    {
      SMSID: 719485,
      DateTime: "11/11/2021 18:59:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700455366,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 371246",
    },
    {
      SMSID: 719501,
      DateTime: "11/11/2021 19:48:50",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771150238,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 883617",
    },
    {
      SMSID: 719515,
      DateTime: "11/11/2021 21:39:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700455366,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 305391",
    },
    {
      SMSID: 719520,
      DateTime: "12/11/2021 02:03:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785231601,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 413484",
    },
    {
      SMSID: 719521,
      DateTime: "12/11/2021 03:41:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740640715,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 714453",
    },
    {
      SMSID: 719546,
      DateTime: "12/11/2021 11:05:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770517104,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 618571",
    },
    {
      SMSID: 719573,
      DateTime: "12/11/2021 11:45:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772829156,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 647653",
    },
    {
      SMSID: 719574,
      DateTime: "12/11/2021 11:45:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772829156,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 518466",
    },
    {
      SMSID: 719575,
      DateTime: "12/11/2021 11:46:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772829156,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 722871",
    },
    {
      SMSID: 719578,
      DateTime: "12/11/2021 11:48:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758753213,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 661898",
    },
    {
      SMSID: 719579,
      DateTime: "12/11/2021 11:49:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758753213,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 572309",
    },
    {
      SMSID: 719606,
      DateTime: "12/11/2021 15:14:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789156281,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 123959",
    },
    {
      SMSID: 719607,
      DateTime: "12/11/2021 15:15:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789156281,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 671303",
    },
    {
      SMSID: 719608,
      DateTime: "12/11/2021 15:18:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789156281,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 492262",
    },
    {
      SMSID: 719658,
      DateTime: "12/11/2021 19:14:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774371042,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 849444",
    },
    {
      SMSID: 719722,
      DateTime: "12/11/2021 20:24:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID318843, has won and the payout UGX16500 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 719751,
      DateTime: "12/11/2021 21:47:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740220504,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 381076",
    },
    {
      SMSID: 719753,
      DateTime: "12/11/2021 22:03:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775173765,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 806673",
    },
    {
      SMSID: 719798,
      DateTime: "13/11/2021 06:27:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788093199,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 385933",
    },
    {
      SMSID: 719799,
      DateTime: "13/11/2021 06:27:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788093199,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 127107",
    },
    {
      SMSID: 719800,
      DateTime: "13/11/2021 06:28:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788093199,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 544257",
    },
    {
      SMSID: 719801,
      DateTime: "13/11/2021 06:57:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784225517,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 423103",
    },
    {
      SMSID: 719802,
      DateTime: "13/11/2021 06:58:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784225517,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 488851",
    },
    {
      SMSID: 719837,
      DateTime: "13/11/2021 10:07:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID318854, has won and the payout UGX625 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 719853,
      DateTime: "13/11/2021 11:53:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708725190,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 587010",
    },
    {
      SMSID: 719854,
      DateTime: "13/11/2021 12:03:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752991200,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 570963",
    },
    {
      SMSID: 719855,
      DateTime: "13/11/2021 12:20:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751573468,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 631604",
    },
    {
      SMSID: 719881,
      DateTime: "13/11/2021 14:37:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786970103,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 484576",
    },
    {
      SMSID: 719887,
      DateTime: "13/11/2021 14:42:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786970103,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 863010",
    },
    {
      SMSID: 719906,
      DateTime: "13/11/2021 16:42:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775179586,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 360600",
    },
    {
      SMSID: 719950,
      DateTime: "13/11/2021 18:54:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754865127,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 530455",
    },
    {
      SMSID: 719970,
      DateTime: "13/11/2021 19:54:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753105906,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 248652",
    },
    {
      SMSID: 720102,
      DateTime: "13/11/2021 21:24:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773161824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 208931",
    },
    {
      SMSID: 720103,
      DateTime: "13/11/2021 21:26:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773161824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 589781",
    },
    {
      SMSID: 720104,
      DateTime: "13/11/2021 21:29:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773161824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 771804",
    },
    {
      SMSID: 720105,
      DateTime: "13/11/2021 21:30:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773161824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 407213",
    },
    {
      SMSID: 720107,
      DateTime: "13/11/2021 21:32:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773161824,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 195508",
    },
    {
      SMSID: 720128,
      DateTime: "14/11/2021 00:18:16",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702182718,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 508347",
    },
    {
      SMSID: 720131,
      DateTime: "14/11/2021 00:49:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774787729,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 361093",
    },
    {
      SMSID: 720140,
      DateTime: "14/11/2021 03:00:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777276888,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 174543",
    },
    {
      SMSID: 720141,
      DateTime: "14/11/2021 03:08:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777276888,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 142303",
    },
    {
      SMSID: 720149,
      DateTime: "14/11/2021 07:19:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705775344,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 346027",
    },
    {
      SMSID: 720152,
      DateTime: "14/11/2021 08:14:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703670022,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 327034",
    },
    {
      SMSID: 720153,
      DateTime: "14/11/2021 08:15:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703670022,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 771324",
    },
    {
      SMSID: 720154,
      DateTime: "14/11/2021 08:16:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703670022,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 391339",
    },
    {
      SMSID: 720155,
      DateTime: "14/11/2021 08:16:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703670022,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 731186",
    },
    {
      SMSID: 720156,
      DateTime: "14/11/2021 08:16:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703670022,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 471283",
    },
    {
      SMSID: 720157,
      DateTime: "14/11/2021 08:20:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740460456,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 293319",
    },
    {
      SMSID: 720158,
      DateTime: "14/11/2021 09:05:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760529030,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 131891",
    },
    {
      SMSID: 720166,
      DateTime: "14/11/2021 09:20:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760529030,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 653767",
    },
    {
      SMSID: 720168,
      DateTime: "14/11/2021 09:35:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256757756060,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 109394",
    },
    {
      SMSID: 720169,
      DateTime: "14/11/2021 09:57:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758333236,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 711991",
    },
    {
      SMSID: 720170,
      DateTime: "14/11/2021 10:25:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700488234,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 301693",
    },
    {
      SMSID: 720206,
      DateTime: "14/11/2021 14:25:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771823079,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 330682",
    },
    {
      SMSID: 720221,
      DateTime: "14/11/2021 14:43:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776383214,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 640243",
    },
    {
      SMSID: 720238,
      DateTime: "14/11/2021 15:39:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775060112,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 823969",
    },
    {
      SMSID: 720242,
      DateTime: "14/11/2021 16:39:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771563606,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 727319",
    },
    {
      SMSID: 720277,
      DateTime: "14/11/2021 20:02:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760255225,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 973277",
    },
    {
      SMSID: 720278,
      DateTime: "14/11/2021 20:03:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760255225,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 450639",
    },
    {
      SMSID: 720301,
      DateTime: "14/11/2021 20:29:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778001250,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 897443",
    },
    {
      SMSID: 720321,
      DateTime: "14/11/2021 21:49:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 291202",
    },
    {
      SMSID: 720322,
      DateTime: "14/11/2021 22:23:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781022396,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 911995",
    },
    {
      SMSID: 720323,
      DateTime: "14/11/2021 23:58:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782512754,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 748693",
    },
    {
      SMSID: 720327,
      DateTime: "15/11/2021 01:21:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753250716,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 772172",
    },
    {
      SMSID: 720348,
      DateTime: "15/11/2021 05:57:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754298566,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 944543",
    },
    {
      SMSID: 720393,
      DateTime: "15/11/2021 11:28:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753887463,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 981765",
    },
    {
      SMSID: 720429,
      DateTime: "15/11/2021 13:21:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781511772,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 406472",
    },
    {
      SMSID: 720440,
      DateTime: "15/11/2021 13:28:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740078225,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 179663",
    },
    {
      SMSID: 720445,
      DateTime: "15/11/2021 13:30:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740078225,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 668434",
    },
    {
      SMSID: 720446,
      DateTime: "15/11/2021 13:31:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740078225,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 783616",
    },
    {
      SMSID: 720494,
      DateTime: "15/11/2021 14:34:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773100744,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 908692",
    },
    {
      SMSID: 720495,
      DateTime: "15/11/2021 14:34:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773100744,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 266528",
    },
    {
      SMSID: 720517,
      DateTime: "15/11/2021 14:57:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID319040, has won and the payout UGX3836 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 720536,
      DateTime: "15/11/2021 15:15:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752229985,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 537007",
    },
    {
      SMSID: 720537,
      DateTime: "15/11/2021 15:19:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702675639,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 488438",
    },
    {
      SMSID: 720593,
      DateTime: "15/11/2021 16:06:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754298566,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 948756",
    },
    {
      SMSID: 720623,
      DateTime: "15/11/2021 16:36:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756212478,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 819731",
    },
    {
      SMSID: 720648,
      DateTime: "15/11/2021 17:13:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753429454,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 401709",
    },
    {
      SMSID: 720653,
      DateTime: "15/11/2021 17:14:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753429454,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 480836",
    },
    {
      SMSID: 720654,
      DateTime: "15/11/2021 17:15:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703458737,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 184131",
    },
    {
      SMSID: 720703,
      DateTime: "15/11/2021 17:51:16",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784577909,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 548651",
    },
    {
      SMSID: 720719,
      DateTime: "15/11/2021 18:37:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760121467,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 250720",
    },
    {
      SMSID: 720722,
      DateTime: "15/11/2021 18:55:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782063639,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 646533",
    },
    {
      SMSID: 720725,
      DateTime: "15/11/2021 19:07:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782063639,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 317256",
    },
    {
      SMSID: 720732,
      DateTime: "15/11/2021 19:14:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785778351,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 188705",
    },
    {
      SMSID: 720736,
      DateTime: "15/11/2021 19:17:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786500161,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 545317",
    },
    {
      SMSID: 720750,
      DateTime: "15/11/2021 19:44:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750441065,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 711713",
    },
    {
      SMSID: 720753,
      DateTime: "15/11/2021 19:49:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256782063639,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 423396",
    },
    {
      SMSID: 720784,
      DateTime: "15/11/2021 21:19:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778272167,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 176558",
    },
    {
      SMSID: 720785,
      DateTime: "15/11/2021 21:19:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778272167,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 539010",
    },
    {
      SMSID: 720786,
      DateTime: "15/11/2021 21:22:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778272167,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 646632",
    },
    {
      SMSID: 720787,
      DateTime: "15/11/2021 21:25:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778272167,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 979822",
    },
    {
      SMSID: 720794,
      DateTime: "15/11/2021 22:12:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756212478,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 240013",
    },
    {
      SMSID: 720795,
      DateTime: "15/11/2021 22:15:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256756212478,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 275404",
    },
    {
      SMSID: 720798,
      DateTime: "15/11/2021 23:59:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770312001,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 798409",
    },
    {
      SMSID: 720799,
      DateTime: "16/11/2021 00:01:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770312001,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 450566",
    },
    {
      SMSID: 720800,
      DateTime: "16/11/2021 00:06:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704251079,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 624594",
    },
    {
      SMSID: 720802,
      DateTime: "16/11/2021 00:41:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256394814066,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 734947",
    },
    {
      SMSID: 720803,
      DateTime: "16/11/2021 00:43:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789416729,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 711661",
    },
    {
      SMSID: 720804,
      DateTime: "16/11/2021 01:47:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770312001,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 660897",
    },
    {
      SMSID: 720853,
      DateTime: "16/11/2021 10:11:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753591348,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 840098",
    },
    {
      SMSID: 720854,
      DateTime: "16/11/2021 10:12:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753591348,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 842389",
    },
    {
      SMSID: 720857,
      DateTime: "16/11/2021 10:17:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753591348,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 717420",
    },
    {
      SMSID: 720864,
      DateTime: "16/11/2021 10:23:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750359552,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 265946",
    },
    {
      SMSID: 720892,
      DateTime: "16/11/2021 10:42:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788267565,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 128071",
    },
    {
      SMSID: 720905,
      DateTime: "16/11/2021 11:54:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700252413,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 479749",
    },
    {
      SMSID: 720924,
      DateTime: "16/11/2021 13:40:50",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256757453567,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 133351",
    },
    {
      SMSID: 720925,
      DateTime: "16/11/2021 13:47:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751742534,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 606010",
    },
    {
      SMSID: 721123,
      DateTime: "16/11/2021 17:52:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778288075,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 253098",
    },
    {
      SMSID: 721133,
      DateTime: "16/11/2021 18:40:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777002995,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 157364",
    },
    {
      SMSID: 721143,
      DateTime: "16/11/2021 18:59:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777002995,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 791759",
    },
    {
      SMSID: 721176,
      DateTime: "16/11/2021 19:43:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772159706,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 466134",
    },
    {
      SMSID: 721230,
      DateTime: "16/11/2021 20:45:41",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772002636,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 955992",
    },
    {
      SMSID: 721238,
      DateTime: "16/11/2021 20:47:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772002637,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 506052",
    },
    {
      SMSID: 721240,
      DateTime: "16/11/2021 20:50:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772002637,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 520035",
    },
    {
      SMSID: 721254,
      DateTime: "16/11/2021 21:34:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780450727,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 208241",
    },
    {
      SMSID: 721255,
      DateTime: "16/11/2021 21:35:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780450727,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 359494",
    },
    {
      SMSID: 721256,
      DateTime: "16/11/2021 21:38:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780450727,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 582488",
    },
    {
      SMSID: 721257,
      DateTime: "16/11/2021 21:39:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780450727,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 711257",
    },
    {
      SMSID: 721258,
      DateTime: "16/11/2021 21:41:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780450727,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 108882",
    },
    {
      SMSID: 721265,
      DateTime: "16/11/2021 22:09:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780450727,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 879388",
    },
    {
      SMSID: 721279,
      DateTime: "17/11/2021 06:22:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 25681274788760,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 464826",
    },
    {
      SMSID: 721282,
      DateTime: "17/11/2021 06:45:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701204404,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 601688",
    },
    {
      SMSID: 721285,
      DateTime: "17/11/2021 08:12:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701164370,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 780535",
    },
    {
      SMSID: 721286,
      DateTime: "17/11/2021 08:14:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701164370,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 780498",
    },
    {
      SMSID: 721288,
      DateTime: "17/11/2021 08:28:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703524277,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 413097",
    },
    {
      SMSID: 721293,
      DateTime: "17/11/2021 09:18:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778778233,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 303183",
    },
    {
      SMSID: 721294,
      DateTime: "17/11/2021 09:27:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783311223,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 481619",
    },
    {
      SMSID: 721307,
      DateTime: "17/11/2021 10:23:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783311223,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 770293",
    },
    {
      SMSID: 721348,
      DateTime: "17/11/2021 13:03:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752385635,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 140743",
    },
    {
      SMSID: 721349,
      DateTime: "17/11/2021 13:04:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752385635,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 716566",
    },
    {
      SMSID: 721390,
      DateTime: "17/11/2021 14:26:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781797535,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 493314",
    },
    {
      SMSID: 721444,
      DateTime: "17/11/2021 17:51:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781797535,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 801944",
    },
    {
      SMSID: 721447,
      DateTime: "17/11/2021 17:53:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781797535,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 440080",
    },
    {
      SMSID: 721493,
      DateTime: "17/11/2021 19:41:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707692434,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 272074",
    },
    {
      SMSID: 721497,
      DateTime: "17/11/2021 19:51:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256755574100,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 109031",
    },
    {
      SMSID: 721579,
      DateTime: "17/11/2021 21:09:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785906005,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 108762",
    },
    {
      SMSID: 721580,
      DateTime: "17/11/2021 21:12:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785906005,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 445931",
    },
    {
      SMSID: 721581,
      DateTime: "17/11/2021 21:14:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785906005,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 510601",
    },
    {
      SMSID: 721585,
      DateTime: "17/11/2021 21:40:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786677030,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 595159",
    },
    {
      SMSID: 721586,
      DateTime: "17/11/2021 22:05:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703874215,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 652403",
    },
    {
      SMSID: 721587,
      DateTime: "17/11/2021 22:08:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703874215,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 422714",
    },
    {
      SMSID: 721598,
      DateTime: "17/11/2021 22:34:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256703524277,
      Interface: "Shortcode",
      Message:
        "You won! BetID322969, has won and the payout UGX18000 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 721599,
      DateTime: "17/11/2021 22:37:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784133606,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 151662",
    },
    {
      SMSID: 721600,
      DateTime: "17/11/2021 22:42:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784707549,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 762076",
    },
    {
      SMSID: 721601,
      DateTime: "17/11/2021 22:50:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760144170,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 859546",
    },
    {
      SMSID: 721602,
      DateTime: "17/11/2021 22:54:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256703524277,
      Interface: "Shortcode",
      Message:
        "You won! BetID322973, has won and the payout UGX14850 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 721603,
      DateTime: "18/11/2021 00:27:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784944814,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 542329",
    },
    {
      SMSID: 721638,
      DateTime: "18/11/2021 08:19:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778557150,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 617899",
    },
    {
      SMSID: 721639,
      DateTime: "18/11/2021 08:21:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778557150,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 921081",
    },
    {
      SMSID: 721640,
      DateTime: "18/11/2021 08:25:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778557150,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 450828",
    },
    {
      SMSID: 721642,
      DateTime: "18/11/2021 08:31:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256757577050,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 161885",
    },
    {
      SMSID: 721686,
      DateTime: "18/11/2021 10:26:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708590078,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 988741",
    },
    {
      SMSID: 721743,
      DateTime: "18/11/2021 13:25:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786680259,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 594888",
    },
    {
      SMSID: 721744,
      DateTime: "18/11/2021 13:25:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786680259,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 499982",
    },
    {
      SMSID: 721745,
      DateTime: "18/11/2021 13:26:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786680259,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 818753",
    },
    {
      SMSID: 721746,
      DateTime: "18/11/2021 13:27:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786680259,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 264038",
    },
    {
      SMSID: 721747,
      DateTime: "18/11/2021 13:28:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786680259,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 615196",
    },
    {
      SMSID: 721780,
      DateTime: "18/11/2021 14:36:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750600095,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 567763",
    },
    {
      SMSID: 721781,
      DateTime: "18/11/2021 14:37:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750600095,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 142497",
    },
    {
      SMSID: 721784,
      DateTime: "18/11/2021 14:38:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750600095,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 828325",
    },
    {
      SMSID: 721787,
      DateTime: "18/11/2021 14:39:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750600095,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 155092",
    },
    {
      SMSID: 721812,
      DateTime: "18/11/2021 14:58:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750600095,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 255713",
    },
    {
      SMSID: 721819,
      DateTime: "18/11/2021 15:01:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256761183054,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 728062",
    },
    {
      SMSID: 721820,
      DateTime: "18/11/2021 15:03:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788090576,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 456951",
    },
    {
      SMSID: 721835,
      DateTime: "18/11/2021 15:20:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788090576,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 498253",
    },
    {
      SMSID: 721836,
      DateTime: "18/11/2021 15:20:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788090576,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 632061",
    },
    {
      SMSID: 721837,
      DateTime: "18/11/2021 15:20:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256788090576,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 926698",
    },
    {
      SMSID: 721872,
      DateTime: "18/11/2021 17:03:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770591358,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 612066",
    },
    {
      SMSID: 721873,
      DateTime: "18/11/2021 17:03:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770591358,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 279741",
    },
    {
      SMSID: 721878,
      DateTime: "18/11/2021 17:11:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703008643,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 241629",
    },
    {
      SMSID: 721879,
      DateTime: "18/11/2021 17:12:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703008643,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 960540",
    },
    {
      SMSID: 721880,
      DateTime: "18/11/2021 17:12:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703008643,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 133795",
    },
    {
      SMSID: 721920,
      DateTime: "18/11/2021 18:39:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774009475,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 829043",
    },
    {
      SMSID: 721925,
      DateTime: "18/11/2021 19:06:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774009475,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 670239",
    },
    {
      SMSID: 721958,
      DateTime: "18/11/2021 19:50:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706721686,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 499759",
    },
    {
      SMSID: 721961,
      DateTime: "18/11/2021 19:52:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706721686,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 642358",
    },
    {
      SMSID: 721964,
      DateTime: "18/11/2021 19:54:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706721686,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 855119",
    },
    {
      SMSID: 721965,
      DateTime: "18/11/2021 19:54:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706721686,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 967399",
    },
    {
      SMSID: 721970,
      DateTime: "18/11/2021 19:58:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706721686,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 808063",
    },
    {
      SMSID: 721972,
      DateTime: "18/11/2021 20:00:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706721686,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 551528",
    },
    {
      SMSID: 721981,
      DateTime: "18/11/2021 20:14:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740579170,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 312254",
    },
    {
      SMSID: 722040,
      DateTime: "18/11/2021 22:07:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779263774,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 599517",
    },
    {
      SMSID: 722059,
      DateTime: "19/11/2021 06:45:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758074108,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 264440",
    },
    {
      SMSID: 722126,
      DateTime: "19/11/2021 11:25:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787813179,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 674365",
    },
    {
      SMSID: 722129,
      DateTime: "19/11/2021 11:29:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787813179,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 743237",
    },
    {
      SMSID: 722134,
      DateTime: "19/11/2021 11:42:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752239589,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 768645",
    },
    {
      SMSID: 722135,
      DateTime: "19/11/2021 11:42:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752239589,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 333336",
    },
    {
      SMSID: 722136,
      DateTime: "19/11/2021 11:43:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752239589,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 739105",
    },
    {
      SMSID: 722172,
      DateTime: "19/11/2021 13:49:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774178892,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 439463",
    },
    {
      SMSID: 722205,
      DateTime: "19/11/2021 14:51:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751348456,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 766408",
    },
    {
      SMSID: 722240,
      DateTime: "19/11/2021 15:19:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781309935,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 255211",
    },
    {
      SMSID: 722241,
      DateTime: "19/11/2021 15:21:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781309935,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 881753",
    },
    {
      SMSID: 722268,
      DateTime: "19/11/2021 15:41:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706721686,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 478117",
    },
    {
      SMSID: 722269,
      DateTime: "19/11/2021 15:56:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: "256O777824133",
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 293279",
    },
    {
      SMSID: 722270,
      DateTime: "19/11/2021 15:57:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: "256O777824133",
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 541834",
    },
    {
      SMSID: 722273,
      DateTime: "19/11/2021 16:06:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751241767,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 858112",
    },
    {
      SMSID: 722278,
      DateTime: "19/11/2021 16:51:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781010570,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 716943",
    },
    {
      SMSID: 722289,
      DateTime: "19/11/2021 17:09:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779175629,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 125934",
    },
    {
      SMSID: 722290,
      DateTime: "19/11/2021 17:10:41",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779175629,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 952450",
    },
    {
      SMSID: 722293,
      DateTime: "19/11/2021 17:15:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779175629,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 122782",
    },
    {
      SMSID: 722294,
      DateTime: "19/11/2021 17:19:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701193751,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 952684",
    },
    {
      SMSID: 722295,
      DateTime: "19/11/2021 17:21:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701193751,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 281536",
    },
    {
      SMSID: 722300,
      DateTime: "19/11/2021 17:25:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789877462,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 756492",
    },
    {
      SMSID: 722331,
      DateTime: "19/11/2021 19:14:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID323676, has won and the payout UGX2500 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 722346,
      DateTime: "19/11/2021 19:31:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759729318,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 865591",
    },
    {
      SMSID: 722347,
      DateTime: "19/11/2021 19:31:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759729318,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 508957",
    },
    {
      SMSID: 722350,
      DateTime: "19/11/2021 19:33:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759729318,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 444059",
    },
    {
      SMSID: 722353,
      DateTime: "19/11/2021 19:34:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759729318,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 156580",
    },
    {
      SMSID: 722377,
      DateTime: "19/11/2021 20:18:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779251311,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 696983",
    },
    {
      SMSID: 722484,
      DateTime: "19/11/2021 22:08:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703528718,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 241880",
    },
    {
      SMSID: 722485,
      DateTime: "19/11/2021 22:10:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785626567,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 328791",
    },
    {
      SMSID: 722486,
      DateTime: "19/11/2021 22:10:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785626567,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 526507",
    },
    {
      SMSID: 722492,
      DateTime: "19/11/2021 23:22:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702212718,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 472172",
    },
    {
      SMSID: 722495,
      DateTime: "20/11/2021 02:01:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779197583,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 513143",
    },
    {
      SMSID: 722496,
      DateTime: "20/11/2021 02:05:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779197583,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 162867",
    },
    {
      SMSID: 722497,
      DateTime: "20/11/2021 02:07:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779197583,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 763205",
    },
    {
      SMSID: 722502,
      DateTime: "20/11/2021 05:42:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700470050,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 122255",
    },
    {
      SMSID: 722503,
      DateTime: "20/11/2021 05:42:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700470050,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 136467",
    },
    {
      SMSID: 722508,
      DateTime: "20/11/2021 06:12:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786218134,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 631241",
    },
    {
      SMSID: 722509,
      DateTime: "20/11/2021 06:18:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770869870,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 531795",
    },
    {
      SMSID: 722514,
      DateTime: "20/11/2021 06:21:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783850678,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 578878",
    },
    {
      SMSID: 722519,
      DateTime: "20/11/2021 06:33:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772014444,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 622967",
    },
    {
      SMSID: 722520,
      DateTime: "20/11/2021 06:47:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778539846,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 389495",
    },
    {
      SMSID: 722523,
      DateTime: "20/11/2021 06:50:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778539846,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 660116",
    },
    {
      SMSID: 722524,
      DateTime: "20/11/2021 07:19:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770562856,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 743368",
    },
    {
      SMSID: 722528,
      DateTime: "20/11/2021 07:44:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751213892,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 818041",
    },
    {
      SMSID: 722533,
      DateTime: "20/11/2021 08:14:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702777568,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 509491",
    },
    {
      SMSID: 722534,
      DateTime: "20/11/2021 08:34:41",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760461565,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 329079",
    },
    {
      SMSID: 722549,
      DateTime: "20/11/2021 09:08:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700470050,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 239250",
    },
    {
      SMSID: 722550,
      DateTime: "20/11/2021 09:22:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770423020,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 629020",
    },
    {
      SMSID: 722559,
      DateTime: "20/11/2021 10:50:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774084503,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 321161",
    },
    {
      SMSID: 722564,
      DateTime: "20/11/2021 11:17:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779029093,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 354825",
    },
    {
      SMSID: 722579,
      DateTime: "20/11/2021 11:47:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771914904,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 257997",
    },
    {
      SMSID: 722582,
      DateTime: "20/11/2021 12:08:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777507528,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 623470",
    },
    {
      SMSID: 722583,
      DateTime: "20/11/2021 12:09:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777507528,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 172262",
    },
    {
      SMSID: 722584,
      DateTime: "20/11/2021 12:18:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779547098,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 270303",
    },
    {
      SMSID: 722585,
      DateTime: "20/11/2021 12:21:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256755542694,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 891614",
    },
    {
      SMSID: 722607,
      DateTime: "20/11/2021 13:20:58",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773569928,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 358752",
    },
    {
      SMSID: 722613,
      DateTime: "20/11/2021 13:51:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774998725,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 466710",
    },
    {
      SMSID: 722616,
      DateTime: "20/11/2021 13:54:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789968144,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 677212",
    },
    {
      SMSID: 722632,
      DateTime: "20/11/2021 14:18:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753524358,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 752893",
    },
    {
      SMSID: 722644,
      DateTime: "20/11/2021 14:38:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740227029,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 484579",
    },
    {
      SMSID: 722674,
      DateTime: "20/11/2021 15:27:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784237304,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 855254",
    },
    {
      SMSID: 722675,
      DateTime: "20/11/2021 15:28:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784237304,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 368982",
    },
    {
      SMSID: 722676,
      DateTime: "20/11/2021 15:29:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784237304,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 343491",
    },
    {
      SMSID: 722677,
      DateTime: "20/11/2021 15:30:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784237304,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 429117",
    },
    {
      SMSID: 722689,
      DateTime: "20/11/2021 15:53:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784237304,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 861241",
    },
    {
      SMSID: 722700,
      DateTime: "20/11/2021 16:17:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256761587238,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 356058",
    },
    {
      SMSID: 722703,
      DateTime: "20/11/2021 16:55:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256782293442,
      Interface: "Shortcode",
      Message:
        "You won! BetID323719, has won and the payout UGX1040 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 722753,
      DateTime: "20/11/2021 18:16:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256782800085,
      Interface: "Shortcode",
      Message:
        "You won! BetID323742, has won and the payout UGX1192 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 722756,
      DateTime: "20/11/2021 18:20:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705498253,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 406257",
    },
    {
      SMSID: 722757,
      DateTime: "20/11/2021 18:23:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705498253,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 846219",
    },
    {
      SMSID: 722758,
      DateTime: "20/11/2021 18:23:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705498253,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 439389",
    },
    {
      SMSID: 722761,
      DateTime: "20/11/2021 18:25:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256782293442,
      Interface: "Shortcode",
      Message:
        "You won! BetID323722, has won and the payout UGX975 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 722766,
      DateTime: "20/11/2021 18:32:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783311223,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 605437",
    },
    {
      SMSID: 722767,
      DateTime: "20/11/2021 18:33:41",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783311223,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 239022",
    },
    {
      SMSID: 722770,
      DateTime: "20/11/2021 18:40:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256783311223,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 844656",
    },
    {
      SMSID: 722771,
      DateTime: "20/11/2021 18:40:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784946678,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 470839",
    },
    {
      SMSID: 722776,
      DateTime: "20/11/2021 19:02:58",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256782293442,
      Interface: "Shortcode",
      Message:
        "You won! BetID323724, has won and the payout UGX8080 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 722777,
      DateTime: "20/11/2021 19:03:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704354164,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 109736",
    },
    {
      SMSID: 722778,
      DateTime: "20/11/2021 19:03:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256782664235,
      Interface: "Shortcode",
      Message:
        "You won! BetID323744, has won and the payout UGX67441 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 722779,
      DateTime: "20/11/2021 19:04:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704354164,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 919069",
    },
    {
      SMSID: 722782,
      DateTime: "20/11/2021 19:12:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256772641039,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 803740",
    },
    {
      SMSID: 722829,
      DateTime: "20/11/2021 22:53:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784237304,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 137484",
    },
    {
      SMSID: 722830,
      DateTime: "20/11/2021 23:43:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 25681274788760,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 916084",
    },
    {
      SMSID: 722831,
      DateTime: "21/11/2021 01:16:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778649966,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 622746",
    },
    {
      SMSID: 722832,
      DateTime: "21/11/2021 01:18:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778649966,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 685973",
    },
    {
      SMSID: 722833,
      DateTime: "21/11/2021 01:19:16",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778649966,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 564934",
    },
    {
      SMSID: 722834,
      DateTime: "21/11/2021 01:41:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778649966,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 654048",
    },
    {
      SMSID: 722837,
      DateTime: "21/11/2021 04:25:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753312366,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 647719",
    },
    {
      SMSID: 722838,
      DateTime: "21/11/2021 05:55:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708434937,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 974985",
    },
    {
      SMSID: 722839,
      DateTime: "21/11/2021 06:49:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752046603,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 587857",
    },
    {
      SMSID: 722840,
      DateTime: "21/11/2021 06:59:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751359901,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 430061",
    },
    {
      SMSID: 722841,
      DateTime: "21/11/2021 07:09:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750654283,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 310333",
    },
    {
      SMSID: 722842,
      DateTime: "21/11/2021 07:13:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750654283,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 428204",
    },
    {
      SMSID: 722843,
      DateTime: "21/11/2021 07:14:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750654283,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 139648",
    },
    {
      SMSID: 722844,
      DateTime: "21/11/2021 07:17:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750654283,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 760142",
    },
    {
      SMSID: 722856,
      DateTime: "21/11/2021 09:29:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752018959,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 132340",
    },
    {
      SMSID: 722857,
      DateTime: "21/11/2021 09:35:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752018959,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 340735",
    },
    {
      SMSID: 722870,
      DateTime: "21/11/2021 10:49:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256775335989,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 523279",
    },
    {
      SMSID: 722871,
      DateTime: "21/11/2021 11:09:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781479825,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 322329",
    },
    {
      SMSID: 722872,
      DateTime: "21/11/2021 11:11:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781479825,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 452817",
    },
    {
      SMSID: 722873,
      DateTime: "21/11/2021 11:14:50",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770848575,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 992236",
    },
    {
      SMSID: 722874,
      DateTime: "21/11/2021 11:16:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256761641670,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 698519",
    },
    {
      SMSID: 722875,
      DateTime: "21/11/2021 11:17:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770848575,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 930707",
    },
    {
      SMSID: 722876,
      DateTime: "21/11/2021 11:29:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706402903,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 160161",
    },
    {
      SMSID: 722903,
      DateTime: "21/11/2021 12:23:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752018959,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 181775",
    },
    {
      SMSID: 722904,
      DateTime: "21/11/2021 12:23:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752018959,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 446925",
    },
    {
      SMSID: 722910,
      DateTime: "21/11/2021 12:54:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256709672399,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 605586",
    },
    {
      SMSID: 722916,
      DateTime: "21/11/2021 13:29:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776115941,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 821389",
    },
    {
      SMSID: 722931,
      DateTime: "21/11/2021 13:49:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256777594236,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 858761",
    },
    {
      SMSID: 722932,
      DateTime: "21/11/2021 14:00:45",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750808997,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 822019",
    },
    {
      SMSID: 722933,
      DateTime: "21/11/2021 14:02:10",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750808997,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 714115",
    },
    {
      SMSID: 722934,
      DateTime: "21/11/2021 14:09:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760629155,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 600299",
    },
    {
      SMSID: 722935,
      DateTime: "21/11/2021 14:10:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740613616,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 229644",
    },
    {
      SMSID: 722936,
      DateTime: "21/11/2021 14:18:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758814810,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 153843",
    },
    {
      SMSID: 722973,
      DateTime: "21/11/2021 15:25:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784907531,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 715615",
    },
    {
      SMSID: 722974,
      DateTime: "21/11/2021 15:44:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256740991914,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 567453",
    },
    {
      SMSID: 722975,
      DateTime: "21/11/2021 15:49:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706216850,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 450371",
    },
    {
      SMSID: 722976,
      DateTime: "21/11/2021 15:50:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706216850,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 486633",
    },
    {
      SMSID: 722979,
      DateTime: "21/11/2021 16:30:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID323805, has won and the payout UGX7600 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 722980,
      DateTime: "21/11/2021 16:41:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID323807, has won and the payout UGX10500 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 722985,
      DateTime: "21/11/2021 17:14:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752750142,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 618343",
    },
    {
      SMSID: 722986,
      DateTime: "21/11/2021 17:15:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752750142,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 471537",
    },
    {
      SMSID: 722998,
      DateTime: "21/11/2021 18:29:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID323820, has won and the payout UGX62500 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 722999,
      DateTime: "21/11/2021 18:49:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID323822, has won and the payout UGX63500 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723015,
      DateTime: "21/11/2021 20:23:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256782800085,
      Interface: "Shortcode",
      Message:
        "You won! BetID323767, has won and the payout UGX1870 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723019,
      DateTime: "21/11/2021 21:01:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256785709406,
      Interface: "Shortcode",
      Message:
        "You won! BetID323749, has won and the payout UGX9428 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723020,
      DateTime: "21/11/2021 21:08:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 2567756299978,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 366081",
    },
    {
      SMSID: 723031,
      DateTime: "22/11/2021 00:48:42",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256784260964,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 767777",
    },
    {
      SMSID: 723067,
      DateTime: "22/11/2021 08:25:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760862351,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 412710",
    },
    {
      SMSID: 723068,
      DateTime: "22/11/2021 08:26:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760862351,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 667573",
    },
    {
      SMSID: 723069,
      DateTime: "22/11/2021 08:27:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760862351,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 627991",
    },
    {
      SMSID: 723070,
      DateTime: "22/11/2021 08:30:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760862351,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 640532",
    },
    {
      SMSID: 723075,
      DateTime: "22/11/2021 09:05:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774222067,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 269027",
    },
    {
      SMSID: 723086,
      DateTime: "22/11/2021 10:24:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773790509,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 773221",
    },
    {
      SMSID: 723089,
      DateTime: "22/11/2021 10:25:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773790509,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 741041",
    },
    {
      SMSID: 723090,
      DateTime: "22/11/2021 10:31:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773790509,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 900612",
    },
    {
      SMSID: 723091,
      DateTime: "22/11/2021 10:34:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773790509,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 340057",
    },
    {
      SMSID: 723115,
      DateTime: "22/11/2021 11:59:14",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781025353,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 708369",
    },
    {
      SMSID: 723169,
      DateTime: "22/11/2021 14:11:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750854461,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 306325",
    },
    {
      SMSID: 723184,
      DateTime: "22/11/2021 14:37:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256774178892,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 865584",
    },
    {
      SMSID: 723194,
      DateTime: "22/11/2021 14:48:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758209780,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 273415",
    },
    {
      SMSID: 723197,
      DateTime: "22/11/2021 14:54:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256758209780,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 150112",
    },
    {
      SMSID: 723200,
      DateTime: "22/11/2021 15:11:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700106207,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 888156",
    },
    {
      SMSID: 723211,
      DateTime: "22/11/2021 15:30:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751241767,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 438406",
    },
    {
      SMSID: 723263,
      DateTime: "22/11/2021 16:14:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752556324,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 195141",
    },
    {
      SMSID: 723271,
      DateTime: "22/11/2021 17:28:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256708030346,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 609039",
    },
    {
      SMSID: 723279,
      DateTime: "22/11/2021 17:43:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781251630,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 246206",
    },
    {
      SMSID: 723296,
      DateTime: "22/11/2021 18:38:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256779547098,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 758712",
    },
    {
      SMSID: 723297,
      DateTime: "22/11/2021 18:39:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771462161,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 108711",
    },
    {
      SMSID: 723309,
      DateTime: "22/11/2021 19:55:21",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325417, has won and the payout UGX12200 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723310,
      DateTime: "22/11/2021 19:56:19",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751241767,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 509453",
    },
    {
      SMSID: 723313,
      DateTime: "22/11/2021 20:44:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325419, has won and the payout UGX14500 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723314,
      DateTime: "22/11/2021 20:53:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776148444,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 247322",
    },
    {
      SMSID: 723315,
      DateTime: "22/11/2021 20:56:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701448752,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 735467",
    },
    {
      SMSID: 723316,
      DateTime: "22/11/2021 21:01:01",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256750313079,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 186413",
    },
    {
      SMSID: 723317,
      DateTime: "22/11/2021 21:02:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325421, has won and the payout UGX12700 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723318,
      DateTime: "22/11/2021 21:22:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325423, has won and the payout UGX16650 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723319,
      DateTime: "22/11/2021 21:23:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256706683842,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 430482",
    },
    {
      SMSID: 723320,
      DateTime: "22/11/2021 21:53:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256702407249,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 909096",
    },
    {
      SMSID: 723326,
      DateTime: "22/11/2021 23:41:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256782800085,
      Interface: "Shortcode",
      Message:
        "You won! BetID323895, has won and the payout UGX6013 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723333,
      DateTime: "23/11/2021 06:39:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753129496,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 163933",
    },
    {
      SMSID: 723334,
      DateTime: "23/11/2021 07:26:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256753129496,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 710885",
    },
    {
      SMSID: 723342,
      DateTime: "23/11/2021 09:15:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256773891669,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 983816",
    },
    {
      SMSID: 723347,
      DateTime: "23/11/2021 10:08:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760586579,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 987865",
    },
    {
      SMSID: 723348,
      DateTime: "23/11/2021 10:14:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781146567,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 100700",
    },
    {
      SMSID: 723349,
      DateTime: "23/11/2021 11:03:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785869864,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 952711",
    },
    {
      SMSID: 723351,
      DateTime: "23/11/2021 12:07:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325442, has won and the payout UGX52000 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723354,
      DateTime: "23/11/2021 12:36:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704960255,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 664430",
    },
    {
      SMSID: 723357,
      DateTime: "23/11/2021 12:38:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751241767,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 434480",
    },
    {
      SMSID: 723358,
      DateTime: "23/11/2021 12:55:52",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776906596,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 104190",
    },
    {
      SMSID: 723359,
      DateTime: "23/11/2021 12:56:50",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776906596,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 705590",
    },
    {
      SMSID: 723360,
      DateTime: "23/11/2021 12:58:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256776906596,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 404471",
    },
    {
      SMSID: 723363,
      DateTime: "23/11/2021 13:10:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760305009,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 881294",
    },
    {
      SMSID: 723364,
      DateTime: "23/11/2021 13:12:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760305009,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 673378",
    },
    {
      SMSID: 723365,
      DateTime: "23/11/2021 13:12:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760305009,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 810158",
    },
    {
      SMSID: 723368,
      DateTime: "23/11/2021 13:44:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701610156,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 527773",
    },
    {
      SMSID: 723373,
      DateTime: "23/11/2021 14:45:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785673990,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 443947",
    },
    {
      SMSID: 723376,
      DateTime: "23/11/2021 15:31:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780907507,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 859159",
    },
    {
      SMSID: 723377,
      DateTime: "23/11/2021 15:32:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780907507,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 507582",
    },
    {
      SMSID: 723380,
      DateTime: "23/11/2021 16:20:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707181555,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 521417",
    },
    {
      SMSID: 723381,
      DateTime: "23/11/2021 16:25:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256703457568,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 777336",
    },
    {
      SMSID: 723382,
      DateTime: "23/11/2021 17:10:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760255225,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 305617",
    },
    {
      SMSID: 723383,
      DateTime: "23/11/2021 17:10:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760255225,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 704506",
    },
    {
      SMSID: 723384,
      DateTime: "23/11/2021 17:15:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781253271,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 229212",
    },
    {
      SMSID: 723385,
      DateTime: "23/11/2021 17:28:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760255225,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 479927",
    },
    {
      SMSID: 723386,
      DateTime: "23/11/2021 17:29:27",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760255225,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 937667",
    },
    {
      SMSID: 723387,
      DateTime: "23/11/2021 17:49:29",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771274872,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 129651",
    },
    {
      SMSID: 723388,
      DateTime: "23/11/2021 17:50:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771274872,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 914294",
    },
    {
      SMSID: 723391,
      DateTime: "23/11/2021 17:52:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705491565,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 293674",
    },
    {
      SMSID: 723392,
      DateTime: "23/11/2021 18:47:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325451, has won and the payout UGX15000 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723394,
      DateTime: "23/11/2021 19:07:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325454, has won and the payout UGX15200 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723398,
      DateTime: "23/11/2021 19:28:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325456, has won and the payout UGX29000 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723399,
      DateTime: "23/11/2021 19:31:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787188938,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 867072",
    },
    {
      SMSID: 723400,
      DateTime: "23/11/2021 19:31:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787188938,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 893846",
    },
    {
      SMSID: 723402,
      DateTime: "23/11/2021 19:34:28",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787188938,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 498273",
    },
    {
      SMSID: 723407,
      DateTime: "23/11/2021 20:15:15",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754298566,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 123425",
    },
    {
      SMSID: 723408,
      DateTime: "23/11/2021 20:15:40",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754298566,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 548778",
    },
    {
      SMSID: 723412,
      DateTime: "23/11/2021 20:31:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770538943,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 588431",
    },
    {
      SMSID: 723413,
      DateTime: "23/11/2021 20:31:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256770538943,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 156650",
    },
    {
      SMSID: 723424,
      DateTime: "23/11/2021 21:41:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325459, has won and the payout UGX14400 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723425,
      DateTime: "23/11/2021 21:44:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID325460, has won and the payout UGX2880 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723427,
      DateTime: "23/11/2021 22:24:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786630943,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 709113",
    },
    {
      SMSID: 723428,
      DateTime: "23/11/2021 22:27:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786630943,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 817638",
    },
    {
      SMSID: 723429,
      DateTime: "23/11/2021 22:31:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786630943,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 739132",
    },
    {
      SMSID: 723430,
      DateTime: "23/11/2021 22:37:51",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752133278,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 661474",
    },
    {
      SMSID: 723431,
      DateTime: "23/11/2021 22:40:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752133278,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 668578",
    },
    {
      SMSID: 723434,
      DateTime: "23/11/2021 23:26:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781765549,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 789223",
    },
    {
      SMSID: 723435,
      DateTime: "23/11/2021 23:26:32",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781765549,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 662747",
    },
    {
      SMSID: 723438,
      DateTime: "23/11/2021 23:34:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787252439,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 811230",
    },
    {
      SMSID: 723439,
      DateTime: "23/11/2021 23:39:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256787252439,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 372181",
    },
    {
      SMSID: 723440,
      DateTime: "24/11/2021 01:02:33",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780678377,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 375695",
    },
    {
      SMSID: 723444,
      DateTime: "24/11/2021 08:44:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704856910,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 774773",
    },
    {
      SMSID: 723449,
      DateTime: "24/11/2021 09:04:06",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781146567,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 485486",
    },
    {
      SMSID: 723450,
      DateTime: "24/11/2021 09:06:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256781146567,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 246762",
    },
    {
      SMSID: 723459,
      DateTime: "24/11/2021 10:33:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789814047,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 120060",
    },
    {
      SMSID: 723460,
      DateTime: "24/11/2021 10:44:41",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789241999,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 887959",
    },
    {
      SMSID: 723461,
      DateTime: "24/11/2021 10:55:22",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789241999,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 281840",
    },
    {
      SMSID: 723462,
      DateTime: "24/11/2021 11:09:47",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785853061,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 430404",
    },
    {
      SMSID: 723463,
      DateTime: "24/11/2021 11:10:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785853061,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 711781",
    },
    {
      SMSID: 723464,
      DateTime: "24/11/2021 11:12:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760168113,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 226031",
    },
    {
      SMSID: 723465,
      DateTime: "24/11/2021 11:24:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785853061,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 139349",
    },
    {
      SMSID: 723466,
      DateTime: "24/11/2021 11:24:48",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785853061,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 197574",
    },
    {
      SMSID: 723469,
      DateTime: "24/11/2021 11:58:30",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256786630943,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 874317",
    },
    {
      SMSID: 723470,
      DateTime: "24/11/2021 12:11:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778063662,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 243660",
    },
    {
      SMSID: 723471,
      DateTime: "24/11/2021 12:12:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256754585468,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 943248",
    },
    {
      SMSID: 723472,
      DateTime: "24/11/2021 12:14:25",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256752133278,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 793366",
    },
    {
      SMSID: 723477,
      DateTime: "24/11/2021 13:24:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325467, has won and the payout UGX11200 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723478,
      DateTime: "24/11/2021 13:32:34",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325469, has won and the payout UGX12700 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723483,
      DateTime: "24/11/2021 13:51:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325471, has won and the payout UGX12500 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723486,
      DateTime: "24/11/2021 14:50:54",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325475, has won and the payout UGX30000 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723487,
      DateTime: "24/11/2021 14:51:55",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789181992,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 332013",
    },
    {
      SMSID: 723488,
      DateTime: "24/11/2021 14:54:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789181992,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 487817",
    },
    {
      SMSID: 723496,
      DateTime: "24/11/2021 15:27:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778699148,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 481894",
    },
    {
      SMSID: 723497,
      DateTime: "24/11/2021 15:28:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778699148,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 292604",
    },
    {
      SMSID: 723508,
      DateTime: "24/11/2021 15:36:04",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789022219,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 923571",
    },
    {
      SMSID: 723509,
      DateTime: "24/11/2021 15:36:50",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID325474, has won and the payout UGX19880 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723511,
      DateTime: "24/11/2021 15:43:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789022219,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 575984",
    },
    {
      SMSID: 723514,
      DateTime: "24/11/2021 15:50:02",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256789022219,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 649684",
    },
    {
      SMSID: 723517,
      DateTime: "24/11/2021 16:24:11",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256778699148,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 626037",
    },
    {
      SMSID: 723518,
      DateTime: "24/11/2021 16:32:53",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325482, has won and the payout UGX12200 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723520,
      DateTime: "24/11/2021 17:50:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325490, has won and the payout UGX15200 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723521,
      DateTime: "24/11/2021 17:55:08",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID325483, has won and the payout UGX4875 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723524,
      DateTime: "24/11/2021 18:24:38",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256751530508,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 444223",
    },
    {
      SMSID: 723526,
      DateTime: "24/11/2021 18:56:43",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID325491, has won and the payout UGX12489 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723527,
      DateTime: "24/11/2021 18:56:44",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256773621767,
      Interface: "Shortcode",
      Message:
        "You won! BetID325496, has won and the payout UGX12200 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723528,
      DateTime: "24/11/2021 19:06:07",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID325494, has won and the payout UGX2745 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723529,
      DateTime: "24/11/2021 19:06:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256701482212,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 490505",
    },
    {
      SMSID: 723530,
      DateTime: "24/11/2021 19:27:56",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID325502, has won and the payout UGX1793 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723531,
      DateTime: "24/11/2021 19:51:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256760776434,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 816286",
    },
    {
      SMSID: 723532,
      DateTime: "24/11/2021 20:06:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707358695,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 170181",
    },
    {
      SMSID: 723533,
      DateTime: "24/11/2021 20:06:12",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 962330",
    },
    {
      SMSID: 723534,
      DateTime: "24/11/2021 20:07:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 762110",
    },
    {
      SMSID: 723535,
      DateTime: "24/11/2021 20:10:23",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 192138",
    },
    {
      SMSID: 723536,
      DateTime: "24/11/2021 20:11:03",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 529345",
    },
    {
      SMSID: 723537,
      DateTime: "24/11/2021 20:13:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 343980",
    },
    {
      SMSID: 723538,
      DateTime: "24/11/2021 20:15:17",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 183168",
    },
    {
      SMSID: 723539,
      DateTime: "24/11/2021 21:14:09",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256785728423,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 584901",
    },
    {
      SMSID: 723540,
      DateTime: "24/11/2021 21:15:05",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "Ugabet",
      To: 256753550863,
      Interface: "Shortcode",
      Message:
        "You won! BetID325505, has won and the payout UGX4924 has been credited to your player wallet. https://ugabet.co.ug/, paybill  for deposit.",
    },
    {
      SMSID: 723541,
      DateTime: "24/11/2021 22:04:18",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256759935300,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 920981",
    },
    {
      SMSID: 723542,
      DateTime: "24/11/2021 22:15:26",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256757494359,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 361340",
    },
    {
      SMSID: 723543,
      DateTime: "24/11/2021 22:21:24",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707045370,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 261894",
    },
    {
      SMSID: 723544,
      DateTime: "24/11/2021 22:44:13",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771595664,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 425775",
    },
    {
      SMSID: 723545,
      DateTime: "24/11/2021 22:44:35",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771595664,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 154195",
    },
    {
      SMSID: 723546,
      DateTime: "24/11/2021 22:45:49",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256771595664,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 852967",
    },
    {
      SMSID: 723547,
      DateTime: "24/11/2021 22:51:59",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256704159167,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 395429",
    },
    {
      SMSID: 723549,
      DateTime: "25/11/2021 01:25:36",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256707447267,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 469871",
    },
    {
      SMSID: 723588,
      DateTime: "25/11/2021 06:05:00",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705014667,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 841639",
    },
    {
      SMSID: 723589,
      DateTime: "25/11/2021 06:05:46",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705014667,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 531104",
    },
    {
      SMSID: 723590,
      DateTime: "25/11/2021 06:06:31",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256705014667,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 672053",
    },
    {
      SMSID: 723599,
      DateTime: "25/11/2021 09:37:58",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 640031",
    },
    {
      SMSID: 723600,
      DateTime: "25/11/2021 09:47:57",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256780450387,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 263998",
    },
    {
      SMSID: 723602,
      DateTime: "25/11/2021 10:01:37",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 221536",
    },
    {
      SMSID: 723603,
      DateTime: "25/11/2021 10:05:20",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 840778",
    },
    {
      SMSID: 723604,
      DateTime: "25/11/2021 10:11:39",
      Source: "Skyline",
      Direction: "Outgoing",
      From: "UGABET",
      To: 256700523122,
      Interface: "Shortcode",
      Message:
        "Use this One Time Password to validate your registration: 209658",
    },
  ]
  return data
}
